"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBase64ImageFromURL = exports.validateFields = exports.ifUserRoleExists = exports.convertDateToEpoch = exports.getCurrentFinancialYear = exports.showHideButtonForText = exports.formatOldQuarter = exports.isProposedQtrValid = exports.handleReport = exports.downloadCustomReport = exports.changeFormat24HrTo12Hr = exports.convertBase64ToFile = exports.convertByteArrayToFile = exports.handleRequest = exports.convertToByteArray = exports.getMultippleSearchPropertyData = exports.getWardListByOfficeID = exports.getSearchPropertyData = exports.getOrderedByData = exports.getCurrentQuarterAndYear = exports.isThereMinimumNoPresent = exports.getAdjournType = exports.downloadFile = exports.downloadBlob = exports.generatePrintableReportExcel = exports.reportPrintHandler = exports.fetchBaseValueForSAF = exports.checkAssessee = exports.checkAssesseeExistOrNot = exports.getSearchResults = exports.formatQuarter = exports.atLeastOneValuesPresentInObject = exports.getHearingOfficer = exports.getWardListForTaxInspector = exports.getWardListForHearingAdmin = exports.getStreetListOnWardChange = exports.getWardListFromOfficeCode = exports.getWardList = exports.fetchStreetName = exports.safSubmitMessage = exports.showSafButtons = exports.atLeastOneValuePresent = exports.areAllValuesPresentInObject = exports.areAllValuesPresentInOwnerArray = exports.areAllValuesPresentInArray = exports.areProvidedObjectKeysPresent = exports.areAllValuesPresent = exports.styles = exports.transformComplaintForComponentUpdate = exports.convertUserForSingleInstance = undefined;
exports.downloadWNSBillFromConsumer = exports.printWNSBill = exports.downloadWNSBill = exports.translate = exports.getResultUrl = exports.getUserSearchedResponse = exports.getFetchBillAPI = exports.getPaymentSearchAPI = exports.getBusinessServiceMdmsData = exports.fetchConsumerBill = exports.searchConsumer = exports.businessServiceInfo = exports.getModuleName = exports.downloadFromLink = exports.openPdf = exports.printPdf = exports.downloadPdf = exports.getMohallaData = exports.isDocumentValid = exports.getApplicationType = exports.navigateToApplication = exports.setRoute = exports.getTotalAmountDue = exports.showToast = exports.onNotificationClick = exports.getTransformedNotifications = exports.getReportDay = exports.hasTokenExpired = exports.trimObj = exports.fetchDropdownData = exports.mergeMDMSDataArray = exports.upperCaseFirst = exports.startSMSRecevier = exports.transformComplaintForComponent = exports.findLatestAssigneeUpdate = exports.findLatestAssignee = exports.getTenantForLatLng = exports.flatten = exports.transformLocalizationLabels = exports.getLatestCreationTime = exports.getCommaSeperatedAddress = exports.returnSLAStatus = exports.getPropertyFromObj = exports.getNamePgrFromId = exports.getNameFromCode = exports.getNameFromId = exports.isFileImage = exports.getFileSize = exports.getTransformedStatus = exports.isImage = exports.getCityNameByCode = exports.fetchImages = exports.getTranslatedLabel = exports.getUlbGradeLabel = exports.prepareFormData = exports.addBodyClass = exports.getBodyClassFromPath = exports.epochToDate = exports.getDateFromEpoch = exports.mapCompIDToName = exports.getCurrentAddress = exports.prepareForm = exports.getRequestUrl = exports.fetchFromLocalStorage = exports.persistInLocalStorage = exports.slugify = exports.isFieldEmpty = exports.addQueryArg = exports.getQueryArg = exports.getGeneralMDMSDataDropdownName = exports.generalMDMSDataRequestObjForWard = exports.generalMDMSDataRequestObj = exports.getTransformedDropdown = exports.getUsageCategory = exports.getCategoryObject = exports.getSingleCodeObject = exports.hyphenSeperatedDateTime = exports.transformById = exports.displayLocalizedStatusMessage = exports.displayStatus = exports.statusToLocalisationKeyMapping = exports.dataTableOptionsWithoutPagination = exports.dataTableOptions = exports.convertDateFormatDDMMYYYY = exports.formatDateToDDMMYYYY = exports.formatMillisecondDate = exports.addDaysOrYearsToDate = exports.formatDateForWaterPayload = exports.formatDateForWater = exports.formatEpochDateForInput = exports.formatEpochDate = exports.formatCurrentDateYear = exports.formatCurrentDate = exports.formatDateFromEpoch = exports.actionUrl = exports.getAcademicYear = exports.formatDateDDMMYYYY = exports.onFormattingNumber = exports.payloadSAF = exports.statusToMessageMapping = undefined;

var _toConsumableArray2 = require("babel-runtime/helpers/toConsumableArray");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _typeof2 = require("babel-runtime/helpers/typeof");

var _typeof3 = _interopRequireDefault(_typeof2);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _slicedToArray2 = require("babel-runtime/helpers/slicedToArray");

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _buttonContainer, _ptFooter;

exports.filterLabelByValue = filterLabelByValue;
exports.getCurrentDateForInput = getCurrentDateForInput;
exports.formatDate = formatDate;
exports.formatDateYYYY = formatDateYYYY;
exports.formatDateToDDMMYYYYDash = formatDateToDDMMYYYYDash;
exports.downloadBase64AsPDF = downloadBase64AsPDF;
exports.checkAllKeysValuesInFormatTable = checkAllKeysValuesInFormatTable;
exports.updateSlots = updateSlots;
exports.convertName = convertName;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _axios = require("axios");

var _axios2 = _interopRequireDefault(_axios);

var _get = require("lodash/get");

var _get2 = _interopRequireDefault(_get);

var _set = require("lodash/set");

var _set2 = _interopRequireDefault(_set);

var _store = require("ui-redux/store");

var _store2 = _interopRequireDefault(_store);

var _isEmpty = require("lodash/isEmpty");

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _common = require("config/common.js");

var _common2 = _interopRequireDefault(_common);

var _endPoints = require("egov-ui-kit/utils/endPoints");

var _endPoints2 = require("./endPoints");

var _translationNode = require("egov-ui-kit/utils/translationNode");

var _translationNode2 = _interopRequireDefault(_translationNode);

var _actions = require("egov-ui-kit/redux/form/actions");

var _api = require("egov-ui-kit/utils/api");

var _formActionUtils = require("./PTCommon/FormWizardUtils/formActionUtils");

var _commons = require("egov-ui-framework/ui-utils/commons");

var _actions2 = require("egov-ui-kit/redux/app/actions");

var _api2 = require("egov-ui-framework/ui-utils/api");

var _formUtils = require("./PTCommon/FormWizardUtils/formUtils");

var _actions3 = require("egov-ui-framework/ui-redux/screen-configuration/actions");

var _generatePDF = require("egov-ui-kit/utils/pdfUtils/generatePDF");

var _actions4 = require("../redux/common/actions");

var _PTServiceUrls = require("egov-ui-kit/common/PTServiceUrls");

var _localStorageUtils = require("egov-ui-kit/utils/localStorageUtils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var statusToMessageMapping = exports.statusToMessageMapping = {
  rejected: "Rejected",
  closed: "Closed",
  open: "Opened",
  "re-assign": "Re-assigned",
  assigned: "Assigned",
  resolved: "Resolved",
  reassignrequested: "Re-assign Requested"
};

// saf dropdown request payload
var payloadSAF = exports.payloadSAF = [{
  moduleName: "PropertyTax",
  masterDetails: [{
    name: "OCCUPENCY_MULTI_FACTOR",
    filter: "",
    moduleCode: "ASMT"
  }, {
    name: "STRUCTURE_MULTI_FACTOR",
    filter: "",
    moduleCode: "ASMT"
  }, {
    name: "USAGE_MULTI_FACTOR",
    filter: "",
    moduleCode: "ASMT"
  }, {
    name: "AGE_MULTI_FACTOR",
    filter: "",
    moduleCode: "ASMT"
  }, {
    name: "LOCATION_MULTI_FACTOR",
    filter: "",
    moduleCode: "ASMT"
  }, {
    name: "UAA_BASE_VALUE",
    filter: "",
    moduleCode: "ASMT"
  }]
}];

function filterLabelByValue(dropdown, enteredValue) {
  var filteredItem = dropdown.find(function (item) {
    return item.value == enteredValue;
  });

  if (filteredItem) {
    return filteredItem.label;
  } else {
    return "";
  }
}

// Formatting quarter
var onFormattingNumber = exports.onFormattingNumber = function onFormattingNumber(qtrNumber) {
  var stringQtrNumber = qtrNumber.toString();
  var formatNumber = +stringQtrNumber.slice(4) + "/" + stringQtrNumber.slice(0, 4);
  return formatNumber;
};

// YYYY-MM-DD -> DD/MM/YYYY
var formatDateDDMMYYYY = exports.formatDateDDMMYYYY = function formatDateDDMMYYYY(inputDate) {
  // Split the input date string by "-"
  var parts = inputDate.split("-");

  // Extract day, month, and year
  var year = parts[0];
  var month = parts[1];
  var day = parts[2];

  // Construct the formatted date string
  var formattedDate = day + "/" + month + "/" + year;

  return formattedDate;
};

var getAcademicYear = exports.getAcademicYear = function getAcademicYear() {
  var now = new Date();
  var year = now.getFullYear();
  var month = now.getMonth() + 1; // JavaScript months are 0-based

  // Assuming academic year starts in April and ends in March
  if (month >= 4) {
    return year + "-" + (year + 1);
  } else {
    return year - 1 + "-" + year;
  }
};

// format epoc date dd/mm/yyyy
var actionUrl = exports.actionUrl = function actionUrl(epoch) {
  if (epoch === null || epoch === undefined) {
    return "";
  }

  var date = new Date(epoch);

  var day = date.getDate().toString().padStart(2, "0");
  var month = (date.getMonth() + 1).toString().padStart(2, "0");
  var year = date.getFullYear();

  var formattedDate = day + "/" + month + "/" + year;

  return formattedDate;
};

// format epoch date to full digit date "MM/DD/YYYY"
var formatDateFromEpoch = exports.formatDateFromEpoch = function formatDateFromEpoch(epoch) {
  // Create a new Date object with the given epoch timestamp in milliseconds
  var date = new Date(epoch);

  // Extract day, month, and year components from the Date object
  var day = date.getDate().toString().padStart(2, "0"); // Add leading zero if the day is a single digit
  var month = (date.getMonth() + 1).toString().padStart(2, "0"); // Month is zero-based, so add 1
  var year = date.getFullYear();

  // Format the date as "MM/DD/YYYY"
  //   const formattedDate = `${month}/${day}/${year}`;
  var formattedDate = day + "/" + month + "/" + year;

  return formattedDate;
};

// convert current date into propoer (dd/mm/yyyy) format
var formatCurrentDate = exports.formatCurrentDate = function formatCurrentDate() {
  var currentDate = new Date();

  var day = currentDate.getDate(),
      month = currentDate.getMonth() + 1,
      year = currentDate.getFullYear();

  var formattedDate = day + "/" + month + "/" + year;
  return formattedDate;
};
// function responsible for currenct date set to input field
function getCurrentDateForInput() {
  var today = new Date();
  var year = today.getFullYear();
  var month = String(today.getMonth() + 1).padStart(2, '0'); // Ensure two digits
  var day = String(today.getDate()).padStart(2, '0'); // Ensure two digits
  return year + "-" + month + "-" + day;
}

// yyyy-mm-dd for Date Fields
var formatCurrentDateYear = exports.formatCurrentDateYear = function formatCurrentDateYear() {
  var currentDate = new Date();

  var day = currentDate.getDate(),
      month = currentDate.getMonth() + 1,
      year = currentDate.getFullYear();

  // Add leading zero to day and month if they are less than 10
  var formattedDay = day < 10 ? "0" + day : day;
  var formattedMonth = month < 10 ? "0" + month : month;

  var formattedDate = year + "-" + formattedMonth + "-" + formattedDay;
  return formattedDate;
};

// format epoc date dd/mm/yyyy
var formatEpochDate = exports.formatEpochDate = function formatEpochDate(epoch) {
  if (epoch === null || epoch === undefined) {
    return "";
  }

  var date = new Date(epoch);

  var day = date.getDate().toString().padStart(2, "0");
  var month = (date.getMonth() + 1).toString().padStart(2, "0");
  var year = date.getFullYear();

  var formattedDate = day + "/" + month + "/" + year;

  return formattedDate;
};

// format epoc date (yyyy-mm-dd)
var formatEpochDateForInput = exports.formatEpochDateForInput = function formatEpochDateForInput(epochDate) {
  // Create a new Date object with the epoch timestamp
  var date = new Date(epochDate);

  // Extract the various components of the date
  var year = date.getFullYear();
  var month = date.getMonth() + 1; // Months are zero-based
  var day = date.getDate();

  // Format the date string
  var formattedDate = year + "-" + month.toString().padStart(2, "0") + "-" + day.toString().padStart(2, "0");
  return formattedDate;
};

var formatDateForWater = exports.formatDateForWater = function formatDateForWater(inputDate) {
  // Split the input date string by either '-' or '/'
  var parts = inputDate.split(/-|\//);

  // Ensure that there are 3 parts (day, month, year)
  if (parts.length !== 3) {
    throw new Error("Invalid date format");
  }

  // Extract day, month, and year from parts
  var day = parseInt(parts[0], 10);
  var month = parseInt(parts[1], 10);
  var year = parseInt(parts[2], 10);
  if (parts[0].length > 2) {
    day = parseInt(parts[2], 10);
    month = parseInt(parts[1], 10);
    year = parseInt(parts[0], 10);
  }
  // Validate day, month, and year
  if (isNaN(day) || isNaN(month) || isNaN(year)) {
    throw new Error("Invalid date format");
  }

  // Create a new Date object with the extracted parts
  var dateNew = new Date(year, month - 1, day);

  // Format the date as "yyyy-mm-dd"
  var date = new Date(dateNew);

  var yearNew = date.getFullYear();
  var monthNew = String(date.getMonth() + 1).padStart(2, "0"); // Adding 1 because getMonth() returns zero-based month index
  var dayNew = String(date.getDate()).padStart(2, "0");

  var formattedDate = yearNew + "-" + monthNew + "-" + dayNew;

  return formattedDate;
};
var formatDateForWaterPayload = exports.formatDateForWaterPayload = function formatDateForWaterPayload(inputDate) {
  if (inputDate) {
    if (inputDate.includes("/")) {
      return inputDate;
    }
    // Split the input date string into year, month, and day
    var parts = inputDate.split("-");
    var day = String(parts[2]).padStart(2, "0");
    var month = String(parts[1]).padStart(2, "0");
    var year = parts[0];
    return day + "/" + month + "/" + year;
  } else return null;
};
var addDaysOrYearsToDate = exports.addDaysOrYearsToDate = function addDaysOrYearsToDate(inputDate, value, unit) {
  var parts = inputDate.split("-");
  var date = new Date(parts[0], parts[1] - 1, parts[2]);
  if (unit === "days") {
    date.setDate(date.getDate() + value);
  } else if (unit === "years") {
    date.setFullYear(date.getFullYear() + value);
  } else {
    // Handle invalid unit
    console.error("Invalid unit. Please provide 'days' or 'years'.");
    return null;
  }

  var year = date.getFullYear();
  var month = String(date.getMonth() + 1).padStart(2, "0");
  var day = String(date.getDate()).padStart(2, "0");

  return year + "-" + month + "-" + day;
};
//format like this yyyy-mm-dd
var formatMillisecondDate = exports.formatMillisecondDate = function formatMillisecondDate(dateMillis) {
  if (dateMillis === null || dateMillis === undefined) {
    return "";
  }
  var formattedDate = new Date(dateMillis).toISOString().split("T")[0];
  return formattedDate;
};

// dd/mm/yyyy to yyyy-mm-dd for Dropdown
function formatDate(inputDate) {
  // Split the original date string into day, month, and year
  var parts = inputDate.split("/");
  var day = parts[0];
  var month = parts[1];
  var year = parts[2];

  // Create a new Date object with the parsed year, month, and day
  var dateObject = new Date(year, month - 1, day);

  // Format the date as "yyyy-mm-dd"
  var formattedDate = dateObject.getFullYear() + "-" + ("0" + (dateObject.getMonth() + 1)).slice(-2) + "-" + ("0" + dateObject.getDate()).slice(-2);

  return formattedDate;
}
// yyyy-mm-dd to yyyy-mm-dd
function formatDateYYYY(inputDate) {
  // Split the original date string into day, month, and year
  var parts = inputDate.split("-");
  var day = parts[1];
  var month = parts[1];
  var year = parts[0];

  // Create a new Date object with the parsed year, month, and day
  var dateObject = new Date(year, month - 1, day);

  // Format the date as "yyyy-mm-dd"
  var formattedDate = dateObject.getFullYear() + "-" + ("0" + (dateObject.getMonth() + 1)).slice(-2) + "-" + ("0" + dateObject.getDate()).slice(-2);

  return formattedDate;
}

// dd/mm/yyyy -> dd-mm-yyyy
function formatDateToDDMMYYYYDash() {
  var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

  var dateStr = date || "";
  if (dateStr) {
    // Split the date string by the "/" separator
    var _dateStr$split = dateStr.split("/"),
        _dateStr$split2 = (0, _slicedToArray3.default)(_dateStr$split, 3),
        day = _dateStr$split2[0],
        month = _dateStr$split2[1],
        year = _dateStr$split2[2];

    // Rearrange the format to "dd-mm-yyyy"


    var formattedDate = day + "-" + month + "-" + year;
    return formattedDate;
  } else {
    return "";
  }
}

// YYYY-MM-DD TO CONVERT DD-MM-YYYY
var formatDateToDDMMYYYY = exports.formatDateToDDMMYYYY = function formatDateToDDMMYYYY(dateString) {
  var date = new Date(dateString);
  var day = String(date.getDate()).padStart(2, "0");
  var month = String(date.getMonth() + 1).padStart(2, "0");
  var year = date.getFullYear();
  return day + "-" + month + "-" + year;
};

// yyyy-mm-dd to dd/mm/yyyy
var convertDateFormatDDMMYYYY = exports.convertDateFormatDDMMYYYY = function convertDateFormatDDMMYYYY(dateString) {
  // Split the date string into an array [year, month, day]
  var _dateString$split = dateString.split('-'),
      _dateString$split2 = (0, _slicedToArray3.default)(_dateString$split, 3),
      year = _dateString$split2[0],
      month = _dateString$split2[1],
      day = _dateString$split2[2];

  // Rearrange and join the parts to form "dd/mm/yyyy"


  var formattedDate = day + "/" + month + "/" + year;

  return formattedDate;
};

var dataTableOptions = exports.dataTableOptions = (0, _defineProperty3.default)({
  selectableRows: false,
  responsive: "simple",
  rowsPerPageOptions: [10, 20, 100],
  rowsPerPage: 10,
  filter: false,
  download: false,
  print: false,
  search: false,
  viewColumns: false,
  hover: true,
  fixedHeader: true
}, "responsive", "scroll");
var dataTableOptionsWithoutPagination = exports.dataTableOptionsWithoutPagination = (0, _defineProperty3.default)({
  pagination: false,
  selectableRows: false,
  responsive: "simple",
  rowsPerPageOptions: [10, 20, 100],
  rowsPerPage: 20,
  filter: false,
  download: false,
  print: false,
  search: false,
  viewColumns: false,
  hover: true,
  fixedHeader: true
}, "responsive", "scroll");

//status messages in home page and my complaints page
var statusToLocalisationKeyMapping = exports.statusToLocalisationKeyMapping = {
  rejected: "Your Complaint has been Rejected",
  closed: "Your Complaint has been Closed",
  open: "Your Complaint has been Filed",
  reopened: "Your Complaint has been Re-opened",
  reassigned: "Your Complaint has been Re-assigned",
  assigned: "Your Complaint has been Assigned",
  resolved: "Your Complaint has been Resolved",
  reassignrequested: "Your Complaint is being Re-Assigned"
};

var displayStatus = exports.displayStatus = function displayStatus(status) {
  return status ? statusToMessageMapping[status && status.toLowerCase()] : "";
};

var displayLocalizedStatusMessage = exports.displayLocalizedStatusMessage = function displayLocalizedStatusMessage(status) {
  return status ? statusToLocalisationKeyMapping[status && status.toLowerCase()] : "";
};

var transformById = exports.transformById = function transformById(payload, id) {
  return payload && payload.reduce(function (result, item) {
    if (!item.hasOwnProperty("active") || item.hasOwnProperty("active") && item.active) {
      result[item[id]] = (0, _extends3.default)({}, item);
    }

    return result;
  }, {});
};

var hyphenSeperatedDateTime = exports.hyphenSeperatedDateTime = function hyphenSeperatedDateTime(d) {
  return d;
};

var getSingleCodeObject = exports.getSingleCodeObject = function getSingleCodeObject(dataKey, tempObj, MDMSdata, keys) {
  keys.forEach(function (key) {
    var splittedKey = key.split(".");
    tempObj[splittedKey[splittedKey.length - 1]] = MDMSdata[dataKey][key];
    tempObj[splittedKey[splittedKey.length - 1]].code = splittedKey[splittedKey.length - 1];
  });
  return tempObj;
};

var getCategoryObject = exports.getCategoryObject = function getCategoryObject(categoryCode, MDMSdata, dataKey, key, parentKey, parentKeyValue) {
  var tempObj = {};
  tempObj[categoryCode] = MDMSdata[dataKey][key];
  tempObj[categoryCode].code = categoryCode;
  tempObj[categoryCode][parentKey] = parentKeyValue;
  return tempObj;
};

var getUsageCategory = exports.getUsageCategory = function getUsageCategory(dataKey, tempObj, MDMSdata, keys) {
  keys.forEach(function (key) {
    var splittedKey = key.split(".");
    var categoryCode = splittedKey.pop();
    if (splittedKey.length === 0) {
      tempObj["UsageCategoryMajor"] = (0, _extends3.default)({}, tempObj["UsageCategoryMajor"], getCategoryObject(categoryCode, MDMSdata, dataKey, key));
    } else if (splittedKey.length === 1) {
      tempObj["UsageCategoryMinor"] = (0, _extends3.default)({}, tempObj["UsageCategoryMinor"], getCategoryObject(categoryCode, MDMSdata, dataKey, key, "usageCategoryMajor", splittedKey[splittedKey.length - 1]));
    } else if (splittedKey.length === 2) {
      tempObj["UsageCategorySubMinor"] = (0, _extends3.default)({}, tempObj["UsageCategorySubMinor"], getCategoryObject(categoryCode, MDMSdata, dataKey, key, "usageCategoryMinor", splittedKey[splittedKey.length - 1]));
    } else if (splittedKey.length === 3) {
      tempObj["UsageCategoryDetail"] = (0, _extends3.default)({}, tempObj["UsageCategoryDetail"], getCategoryObject(categoryCode, MDMSdata, dataKey, key, "usageCategorySubMinor", splittedKey[splittedKey.length - 1]));
    }
  });
  return tempObj;
};

var getTransformedDropdown = exports.getTransformedDropdown = function getTransformedDropdown(MDMSdata, dataKeys) {
  dataKeys.forEach(function (dataKey) {
    if (MDMSdata && MDMSdata.hasOwnProperty(dataKey)) {
      var keys = MDMSdata[dataKey] && Object.keys(MDMSdata[dataKey]);
      var tempObj = {};
      if (keys && keys.length > 0) {
        if (dataKey !== "UsageCategory") {
          MDMSdata[dataKey] = getSingleCodeObject(dataKey, tempObj, MDMSdata, keys);
        } else {
          MDMSdata = (0, _extends3.default)({}, MDMSdata, getUsageCategory(dataKey, tempObj, MDMSdata, keys));
        }
      }
    }
  });
  return MDMSdata;
};

var generalMDMSDataRequestObj = exports.generalMDMSDataRequestObj = function generalMDMSDataRequestObj(tenantId) {
  var requestBody = {
    MdmsCriteria: {
      tenantId: tenantId,
      moduleDetails: [{
        moduleName: "PropertyTax",
        masterDetails: [{ name: "Floor" }, { name: "OccupancyType" }, { name: "OwnerShipCategory" }, { name: "OwnerType" }, { name: "PropertySubType" }, { name: "PropertyType" }, { name: "SubOwnerShipCategory" }, { name: "UsageCategory" }, { name: "characterOfPremiseType" }, { name: "PremisesType" }, { name: "buildingType" }, { name: "OwnershipType" }, { name: "ward" }]
      }]
    }
  };
  return requestBody;
};
var generalMDMSDataRequestObjForWard = exports.generalMDMSDataRequestObjForWard = function generalMDMSDataRequestObjForWard(tenantId) {
  var requestBody = {
    MdmsCriteria: {
      tenantId: tenantId,
      moduleDetails: [{
        moduleName: "PropertyTax",
        masterDetails: [{ name: "ward" }]
      }]
    }
  };
  return requestBody;
};

var getGeneralMDMSDataDropdownName = exports.getGeneralMDMSDataDropdownName = function getGeneralMDMSDataDropdownName() {
  var keys = ["Floor", "OccupancyType", "OwnerShipCategory", "OwnerType", "PropertySubType", "PropertyType", "SubOwnerShipCategory", "UsageCategory", "characterOfPremiseType", "buildingType", "PremisesType", "OwnershipType"];
  return keys;
};

var getQueryArg = exports.getQueryArg = function getQueryArg(url, name) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
};

var addQueryArg = exports.addQueryArg = function addQueryArg(url) {
  var queries = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  var urlParts = url.split("?");
  var path = urlParts[0];
  var queryParts = urlParts.length > 1 ? urlParts[1].split("&") : [];
  queries.forEach(function (query) {
    var key = query.key;
    var value = query.value;
    var newQuery = key + "=" + value;
    queryParts.push(newQuery);
  });
  var newUrl = path + "?" + queryParts.join("&");
  return newUrl;
};

var isFieldEmpty = exports.isFieldEmpty = function isFieldEmpty(field) {
  if (field === undefined || field === null) {
    return true;
  }
  if ((typeof field === "undefined" ? "undefined" : (0, _typeof3.default)(field)) !== "object") {
    field = field.toString().trim();
    return (0, _isEmpty2.default)(field);
  }
  return false;
};

var slugify = exports.slugify = function slugify(term) {
  return term.toLowerCase().replace(/\s+/, "-");
};

var persistInLocalStorage = exports.persistInLocalStorage = function persistInLocalStorage(obj) {
  Object.keys(obj).forEach(function (objKey) {
    var objValue = obj[objKey];
    (0, _localStorageUtils.localStorageSet)(objKey, objValue);
  }, undefined);
};

var fetchFromLocalStorage = exports.fetchFromLocalStorage = function fetchFromLocalStorage(key) {
  return (0, _localStorageUtils.localStorageGet)(key) || null;
};

var getRequestUrl = exports.getRequestUrl = function getRequestUrl(url, params) {
  var query = Object.keys(params).map(function (k) {
    return encodeURIComponent(k) + "=" + encodeURIComponent(params[k]);
  }).join("&");
  return url + "?" + query;
};

var prepareForm = exports.prepareForm = function prepareForm(params) {
  var formData = new FormData();
  for (var k in params) {
    formData.append(k, params[k]);
  }
  return formData;
};

var getMonthName = function getMonthName(monthIndex) {
  switch (monthIndex) {
    case 1:
      return "Jan";
    case 2:
      return "Feb";
    case 3:
      return "Mar";
    case 4:
      return "Apr";
    case 5:
      return "May";
    case 6:
      return "Jun";
    case 7:
      return "Jul";
    case 8:
      return "Aug";
    case 9:
      return "Sep";
    case 10:
      return "Oct";
    case 11:
      return "Nov";
    case 12:
      return "Dec";
    default:
      return "";
  }
};

// const getCurrLocation = () => {
//   return new Promise((resolve) => {
//     if (navigator.geolocation) {
//       navigator.geolocation.getCurrentPosition((position) => {
//         const currLoc = {};
//         currLoc.lat = position.coords.latitude.toFixed(6);
//         currLoc.lng = position.coords.longitude.toFixed(6);
//         resolve(currLoc);
//       });
//     }
//   });
// };

var getCurrentAddress = exports.getCurrentAddress = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));

  return function getCurrentAddress() {
    return _ref.apply(this, arguments);
  };
}();

var mapCompIDToName = exports.mapCompIDToName = function mapCompIDToName(IDObj, compID) {
  return IDObj[compID] ? IDObj[compID].serviceCode : compID;
};

var getDateFromEpoch = exports.getDateFromEpoch = function getDateFromEpoch(epoch) {
  var dateObj = new Date(epoch);
  var year = dateObj.getFullYear().toString().slice(2, 4);
  var month = getMonthName(dateObj.getMonth() + 1);
  var day = dateObj.getDate();
  return day + "-" + month + "-" + year;
};

var epochToDate = exports.epochToDate = function epochToDate(et) {
  if (!et) return null;
  var date = new Date(Math.round(Number(et)));
  var formattedDate = date.getDate() + "/" + (date.getMonth() + 1) + "/" + date.getFullYear();
  return formattedDate;
};

var getBodyClassFromPath = exports.getBodyClassFromPath = function getBodyClassFromPath(path) {
  var bodyClass = path.split("/").filter(function (part) {
    return part.trim().length > 0;
  }).join("-");
  return bodyClass;
};

// remove the previous tokens; temp fix
// forEach not present in the prototype chain of some older browsers
var addBodyClass = exports.addBodyClass = function addBodyClass(path) {
  var bodyClass = getBodyClassFromPath(path);
  try {
    document.body.classList.forEach(function (className) {
      return document.body.classList.remove(className);
    });
    bodyClass && document.body.classList.add(bodyClass);
  } catch (error) {}
};

var prepareFormData = exports.prepareFormData = function prepareFormData(form) {
  var formFields = form.fields;
  return Object.keys(formFields).reduce(function (formData, fieldKey) {
    var _formFields$fieldKey = formFields[fieldKey],
        file = _formFields$fieldKey.file,
        jsonPath = _formFields$fieldKey.jsonPath;
    var value = formFields[fieldKey].value;

    if (file) {
      value = (form.files && form.files[fieldKey] || []).map(function (fieldFile) {
        return fieldFile.fileStoreId;
      });
    }
    return (0, _set2.default)(formData, jsonPath, value);
  }, {});
};

var getUlbGradeLabel = exports.getUlbGradeLabel = function getUlbGradeLabel(ulbGrade) {
  if (ulbGrade) {
    var ulbWiseHeaderName = ulbGrade.toUpperCase();
    if (ulbWiseHeaderName.indexOf(" ") > 0) {
      ulbWiseHeaderName = ulbWiseHeaderName.split(" ").join("_");
    }
    return "ULBGRADE" + "_" + ulbWiseHeaderName;
  }
};

var getTranslatedLabel = exports.getTranslatedLabel = function getTranslatedLabel(labelKey, localizationLabels) {
  var translatedLabel = null;
  if (localizationLabels && localizationLabels.hasOwnProperty(labelKey)) {
    translatedLabel = localizationLabels[labelKey];
    if (translatedLabel && (typeof translatedLabel === "undefined" ? "undefined" : (0, _typeof3.default)(translatedLabel)) === "object" && translatedLabel.hasOwnProperty("message")) translatedLabel = translatedLabel.message;
  }
  return translatedLabel || labelKey;
};

var fetchImages = exports.fetchImages = function fetchImages(actionArray) {
  var imageArray = [];
  actionArray.forEach(function (action, index) {
    action.action === "open" && action.media && imageArray.push(action.media);
  });
  return imageArray[0] ? imageArray[0] : [];
};

// export const getUserInfo = () => {
//   let userInfo = getUserInfo();
//   try {
//     userInfo = JSON.parse(userInfo);
//   } catch (error) {
//     userInfo = null;
//   }
//   return userInfo;
// };

var getCityNameByCode = exports.getCityNameByCode = function getCityNameByCode(code, localizationLabels) {
  var tenantId = code && code.replace(".", "_").toUpperCase();
  return code && getTranslatedLabel("TENANT_TENANTS_" + tenantId, localizationLabels);
};

var isImage = exports.isImage = function isImage(url) {
  var acceptedImageTypes = ["jpg", "jpeg", "png"];
  var urlParts = url && url.split("?");
  var imageType = urlParts && urlParts.length && urlParts[0].split(".") && urlParts[0].split(".").length && urlParts[0].split(".").pop();
  return imageType && acceptedImageTypes.indexOf(imageType) !== -1 || false;
};

//using in Employee Screens
var dateDiffInDays = function dateDiffInDays(a, b) {
  var millsPerDay = 1000 * 60 * 60 * 24;
  var utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
  var utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());
  return Math.floor((utc2 - utc1) / millsPerDay);
};

// export const getCommaSeperatedAddress = (buildingName, street) => {
//   return buildingName && street ? `${buildingName}, ${street}` : "NA";
// };

var getTransformedStatus = exports.getTransformedStatus = function getTransformedStatus(status) {
  var transformedStatus = "";
  switch (status && status.toLowerCase()) {
    case "open":
    case "new":
    case "reassignrequested":
    case "escalatedlevel1pending":
    case "escalatedlevel2pending":
      transformedStatus = "UNASSIGNED";
      break;
    case "resolved":
    case "rejected":
    case "closed":
      transformedStatus = "CLOSED";
      break;
    case "assigned":
    case "escalatedlevel1assigned":
    case "escalatedlevel2assigned":
    case "attended":
    case "pendingkmcgroapproval":
      transformedStatus = "ASSIGNED";
      break;
    // case "escalatedlevel1pending":
    //   transformedStatus = "ESCALATED";
    //   break;
    // case "escalatedlevel2pending":
    //   transformedStatus = "ESCALATED";
    //   break;
    default:
      transformedStatus = "UNASSIGNED";
      break;
  }
  return transformedStatus;
};

var getFileSize = exports.getFileSize = function getFileSize(file) {
  var size = parseFloat(file.size / 1024).toFixed(2);
  return size;
};

var isFileImage = exports.isFileImage = function isFileImage(file) {
  var mimeType = file["type"];
  return mimeType && mimeType.split("/")[0] == "image" || false;
};

var getNameFromId = exports.getNameFromId = function getNameFromId(obj, id, defaultValue) {
  return obj && id && obj[id] ? obj[id].name : defaultValue;
};
var getNameFromCode = exports.getNameFromCode = function getNameFromCode(obj, id, defaultValue) {
  var nameObject = obj && obj.filter(function (obj) {
    return obj.code == id;
  });
  return nameObject ? nameObject && nameObject[0].name && nameObject[0].name : defaultValue;
};
var getNamePgrFromId = exports.getNamePgrFromId = function getNamePgrFromId(obj, id, defaultValue) {
  return obj && obj["" + id] ? obj["" + id]["name"] : defaultValue;
};

var getPropertyFromObj = exports.getPropertyFromObj = function getPropertyFromObj(obj, id, property, defaultValue) {
  return obj && obj[id] ? obj[id][property] : defaultValue;
};

var returnSLAStatus = exports.returnSLAStatus = function returnSLAStatus(slaHours, submittedTime) {
  var millsToAdd = slaHours * 60 * 60 * 1000;
  var toBeFinishedBy = millsToAdd + submittedTime;
  var slaStatement = "";
  var daysCount = dateDiffInDays(new Date(Date.now()), new Date(toBeFinishedBy));
  if (daysCount < 0) {
    // slaStatement = Math.abs(daysCount) === 1 ? "CS_OVERDUE_BY_DAY" : "CS_OVERDUE_BY_DAYS";
    slaStatement = Math.abs(daysCount) === 1 ? "Overdue by " + Math.abs(daysCount) + " day" : "Overdue by " + Math.abs(daysCount) + " days";
  } else {
    // slaStatement = Math.abs(daysCount) === 1 ? "CS_DAY_LEFT" : "CS_DAYS_LEFT";
    slaStatement = Math.abs(daysCount) === 1 ? Math.abs(daysCount) + " day left" : Math.abs(daysCount) + " days left";
  }
  return {
    slaStatement: slaStatement,
    daysCount: daysCount
  };
};

var getCommaSeperatedAddress = exports.getCommaSeperatedAddress = function getCommaSeperatedAddress(address, cities) {
  var name = address && address.locality && address.locality.name ? address.locality.name : "";
  var cityName = address && address.city ? address.city : "";
  var pincode = address && address.pincode ? address.pincode : "";
  // cities &&
  //   cities.forEach((city) => {
  //     if (city.code === cityValue) {
  //       cityName = city.name;
  //     }
  //   });
  var addressKeys = ["doorNo", "buildingName", "street"];
  var addressArray = addressKeys.reduce(function (result, curr) {
    if (address && address[curr]) {
      result.push(address[curr]);
    }
    return [].concat((0, _toConsumableArray3.default)(result));
  }, []);
  addressArray = pincode ? [].concat((0, _toConsumableArray3.default)(addressArray), [name, cityName, pincode]) : [].concat((0, _toConsumableArray3.default)(addressArray), [name, cityName]);
  return addressArray.join(", ");
};

var getLatestCreationTime = exports.getLatestCreationTime = function getLatestCreationTime(complaint) {
  for (var i = 0; i < complaint.actions.length; i++) {
    if (complaint.actions[i].action === "reopen") {
      return complaint.actions[i].when;
    }
  }
  return complaint.slaEndTime;
};

var transformLocalizationLabels = exports.transformLocalizationLabels = function transformLocalizationLabels(localizationLabels) {
  var labelsById = transformById(localizationLabels, "code");
  return labelsById;
};

var flatten = exports.flatten = function flatten(arr) {
  return arr.reduce(function (flat, toFlatten) {
    return flat.concat(Array.isArray(toFlatten) ? undefined.flatten(toFlatten) : toFlatten);
  }, []);
};

var getTenantForLatLng = exports.getTenantForLatLng = function () {
  var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(lat, lng) {
    var queryObjList, response;
    return _regenerator2.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            queryObjList = [{ key: "lat", value: lat }, { key: "lng", value: lng }, { key: "tenantId", value: _common2.default.tenantId }];
            response = void 0;

            if (!(lat && lng)) {
              _context2.next = 13;
              break;
            }

            _context2.prev = 3;
            _context2.next = 6;
            return (0, _api.httpRequest)(_endPoints.TENANT.POST.URL, _endPoints.TENANT.POST.ACTION, queryObjList);

          case 6:
            response = _context2.sent;
            return _context2.abrupt("return", response.Tenant.code);

          case 10:
            _context2.prev = 10;
            _context2.t0 = _context2["catch"](3);
            throw new Error(_context2.t0.message);

          case 13:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, undefined, [[3, 10]]);
  }));

  return function getTenantForLatLng(_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();

var findLatestAssignee = exports.findLatestAssignee = function findLatestAssignee(actionArray) {
  for (var i = 0; i < actionArray.length; i++) {
    if (actionArray[i].status === "assigned" || actionArray[i].status === "escalatedlevel1assigned" || actionArray[i].status === "escalatedlevel2assigned") {
      return actionArray[i].assignee;
    }
  }
  return null;
};
var findLatestAssigneeUpdate = exports.findLatestAssigneeUpdate = function findLatestAssigneeUpdate(actionArray) {
  var reopen = actionArray.filter(function (x) {
    return x.action === "reopen";
  });
  var index = 0;
  if (reopen.length > 0) {
    var lastassignee = actionArray.filter(function (x) {
      return x.assignee !== undefined;
    });
    if (lastassignee && lastassignee.length) {
      return lastassignee[lastassignee.length - 1].assignee;
    }
  } else {
    for (var i = 0; i < actionArray.length; i++) {
      index = actionArray.length - 1;
      if (actionArray[i].status === "assigned" || actionArray[i].status === "escalatedlevel1assigned" || actionArray[i].status === "escalatedlevel2assigned") {
        //return actionArray[i].assignee;
        return actionArray[index].assignee;
      }
    }
  }

  return null;
};
var getLatestAction = function getLatestAction(actionArr) {
  return actionArr.reduce(function (result, current) {
    if (current.when > result) {
      result = current.when;
    }
    return result;
  }, 0);
};

// export const getAddressDetail = (addressDetail) => {
//   const { houseNoAndStreetName, landmark, mohalla, city } = addressDetail;
//   return houseNoAndStreetName && landmark
//     ? `${houseNoAndStreetName},${mohalla},${landmark},${city}`
//     : !houseNoAndStreetName && landmark
//     ? `${mohalla},${landmark},${city}`
//     : houseNoAndStreetName && !landmark
//     ? `${houseNoAndStreetName},${mohalla},${city}`
//     : `${mohalla},${city}`;
// };

var transformComplaintForComponent = exports.transformComplaintForComponent = function transformComplaintForComponent(complaints, role, employeeById, citizenById, categoriesById, displayStatus) {
  var defaultPhoneNumber = "";
  var transformedComplaints = Object.values(complaints.byId).map(function (complaintDetail, index) {
    var filedUserName = complaintDetail && complaintDetail.citizen && complaintDetail.citizen.name;
    var isFiledByCSR = complaintDetail && complaintDetail.actions && complaintDetail.actions[complaintDetail.actions.length - 1].by && complaintDetail.actions[complaintDetail.actions.length - 1].by.split(":")[1] && complaintDetail.actions[complaintDetail.actions.length - 1].by.split(":")[1] === "Citizen Service Representative";
    return {
      header: getPropertyFromObj(complaints.categoriesById, complaintDetail.serviceCode, "serviceCode", "" + complaintDetail.serviceCode),
      date: complaintDetail.auditDetails.createdTime,
      latestCreationTime: getLatestCreationTime(complaintDetail),
      complaintNo: complaintDetail.serviceRequestId,
      category: complaintDetail.category,
      source: complaintDetail.source && complaintDetail.source,
      images: fetchImages(complaintDetail.actions).filter(function (imageSource) {
        // isImage(imageSource);
        return true;
      }),
      complaintStatus: complaintDetail.status && getTransformedStatus(complaintDetail.status),
      rawStatus: complaintDetail.status && complaintDetail.status,
      servicetype: complaintDetail.servicetype && complaintDetail.servicetype,
      prevDept: complaintDetail.prevDept && complaintDetail.prevDept,
      address: complaintDetail.address ? complaintDetail.address : "",
      addressDetail: complaintDetail.addressDetail ? complaintDetail.addressDetail : {},
      reassign: complaintDetail.status === "reassignrequested" ? true : false,
      reassignRequestedBy: complaintDetail.status === "reassignrequested" ? getPropertyFromObj(employeeById, complaintDetail.actions[0].by.split(":")[0], "name", "NA") : "NA",
      latestActionTime: complaintDetail && complaintDetail.actions && getLatestAction(complaintDetail.actions),
      //
      submittedBy: filedUserName ? isFiledByCSR ? filedUserName + " (Citizen Service Desk)" : filedUserName : "NA",
      citizenPhoneNumber: complaintDetail && complaintDetail.citizen && complaintDetail.citizen.mobileNumber,
      assignedTo: complaintDetail && getPropertyFromObj(employeeById, findLatestAssignee(complaintDetail.actions), "name", "NA"),
      // no need
      employeePhoneNumber: employeeById && employeeById[findLatestAssignee(complaintDetail.actions)] ? employeeById[findLatestAssignee(complaintDetail.actions)].mobileNumber : defaultPhoneNumber,
      status: role === "citizen" ? displayStatus(complaintDetail.status, complaintDetail.assignee, complaintDetail.actions.filter(function (complaint) {
        return complaint.status;
      })[0].action) : getTransformedStatus(complaintDetail.status) === "CLOSED" ? complaintDetail.rating ? displayStatus(complaintDetail.rating + "/5") : displayStatus(complaintDetail.actions[0].status) : displayStatus(returnSLAStatus(getPropertyFromObj(categoriesById, complaintDetail.serviceCode, "slaHours", 0), getLatestCreationTime(complaintDetail)).slaStatement),
      SLA: returnSLAStatus(getPropertyFromObj(categoriesById, complaintDetail.serviceCode, "slaHours", 0), getLatestCreationTime(complaintDetail)).daysCount
    };
  });
  return transformedComplaints;
};

var startSMSRecevier = exports.startSMSRecevier = function startSMSRecevier() {
  try {
    if (typeof androidAppProxy !== "undefined") {
      window.androidAppProxy.requestSMS();
    }
  } catch (error) {}
};

var upperCaseFirst = exports.upperCaseFirst = function upperCaseFirst(word) {
  return word[0].toUpperCase() + word.slice(1, word.length);
};

//Specific for MDMS Screens
var mergeMDMSDataArray = exports.mergeMDMSDataArray = function mergeMDMSDataArray(oldData, newRow) {
  var rawData = [].concat((0, _toConsumableArray3.default)(oldData));
  rawData.forEach(function (item, index) {
    if (item.code === newRow.code) {
      //Update Case
      rawData.splice(index, 1);
    }
  });
  var mergedData = [newRow].concat((0, _toConsumableArray3.default)(rawData));
  return mergedData;
};

var fetchDropdownData = exports.fetchDropdownData = function () {
  var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(dispatch, dataFetchConfig, formKey, fieldKey, state, boundary) {
    var url, action, requestBody, queryParams, hierarchyType, localizationLabels, payloadSpec, dropdownData, ddData, message;
    return _regenerator2.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            url = dataFetchConfig.url, action = dataFetchConfig.action, requestBody = dataFetchConfig.requestBody, queryParams = dataFetchConfig.queryParams, hierarchyType = dataFetchConfig.hierarchyType;
            _context3.prev = 1;

            if (!url) {
              _context3.next = 11;
              break;
            }

            localizationLabels = {};

            if (state && state.app) localizationLabels = state.app && state.app.localizationLabels || {};
            _context3.next = 7;
            return (0, _api.httpRequest)(url, action, queryParams || [], requestBody);

          case 7:
            payloadSpec = _context3.sent;
            dropdownData = boundary ? // ? jp.query(payloadSpec, dataFetchConfig.dataPath)
            payloadSpec.TenantBoundary[0].boundary : dataFetchConfig.dataPath.reduce(function (dropdownData, path) {
              dropdownData = [].concat((0, _toConsumableArray3.default)(dropdownData), (0, _toConsumableArray3.default)((0, _get2.default)(payloadSpec, path)));
              return dropdownData;
            }, []);
            ddData = dropdownData && dropdownData.length > 0 && dropdownData.reduce(function (ddData, item) {
              var option = {};
              if (fieldKey === "mohalla" && item.code) {
                var mohallaCode = queryParams[0].value.toUpperCase().replace(/[.]/g, "_") + "_" + hierarchyType + "_" + item.code.toUpperCase().replace(/[._:-\s\/]/g, "_");
                option = {
                  label: getTranslatedLabel(mohallaCode, localizationLabels),
                  value: item.code
                };
              } else {
                option = {
                  label: item.name,
                  value: item.code
                };
              }

              // let option = {
              //   label:
              //     fieldKey === "mohalla"
              //       ? `${queryParams[0].value.toUpperCase().replace(/[.]/g, "_")}_${hierarchyType}_${item.code.toUpperCase().replace(/[._:-\s\/]/g, "_")}`
              //       : item.name,
              //   value: item.code,
              // };
              //Only for boundary
              item.area && (option.area = item.area);
              ddData.push(option);
              return ddData;
            }, []);

            dispatch((0, _actions.setFieldProperty)(formKey, fieldKey, "dropDownData", ddData));

          case 11:
            _context3.next = 18;
            break;

          case 13:
            _context3.prev = 13;
            _context3.t0 = _context3["catch"](1);
            message = _context3.t0.message;

            if (fieldKey === "mohalla") {
              dispatch((0, _actions2.toggleSnackbarAndSetText)(true, { labelName: "There is no admin boundary data available for this tenant", labelKey: "ERR_NO_ADMIN_BOUNDARY_FOR_TENANT" }, "error"));
            } else {
              dispatch((0, _actions2.toggleSnackbarAndSetText)(true, { labelName: message, labelKey: message }, "error"));
            }
            return _context3.abrupt("return");

          case 18:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, undefined, [[1, 13]]);
  }));

  return function fetchDropdownData(_x5, _x6, _x7, _x8, _x9, _x10) {
    return _ref3.apply(this, arguments);
  };
}();

var trimObj = exports.trimObj = function trimObj(obj) {
  if (!Array.isArray(obj) && (typeof obj === "undefined" ? "undefined" : (0, _typeof3.default)(obj)) != "object") return obj;
  for (var key in obj) {
    obj[key.trim()] = typeof obj[key] === "string" ? obj[key].trim() : trimObj(obj[key]);
    if (key === "") delete obj[key];
  }
  return obj;
};

var hasTokenExpired = exports.hasTokenExpired = function hasTokenExpired(status, data) {
  if (status === 401) {
    if (data && data.Errors && Array.isArray(data.Errors) && data.Errors.length > 0 && data.Errors[0].code === "InvalidAccessTokenException") return true;
  } else if (status === 500) {
    if (data && data.Errors && Array.isArray(data.Errors) && data.Errors.length > 0 && data.Errors[0].code === "BadRequest") return true;
  }
  return false;
};

var getEndpointfromUrl = function getEndpointfromUrl(url, name) {
  if (url && url.includes("digit-ui")) {
    return url;
  }
  var result = url.split(name + "=")[1];
  return result;
};

var getTimeFormat = function getTimeFormat(epochTime) {
  epochTime = new Date(epochTime);
  var Period = epochTime.getHours() < 12 ? "AM" : "PM";
  var Format = epochTime.getHours() % 12 > 0 ? epochTime.getHours() % 12 : 12;
  return Format.toString() + ":" + epochTime.toString().split(":")[1] + " " + Period;
};
var getDateFormat = function getDateFormat(epochTime) {
  var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "June", "July", "Aug", "Sep", "Oct", "Nov", "Dec"];
  epochTime = new Date(epochTime);
  var day = epochTime.getDate();
  var Month = epochTime.getMonth();
  return day.toString() + " " + monthNames[Month];
};

var getEventSLA = function getEventSLA(item) {
  var days = (Date.now() - item.auditDetails.lastModifiedTime) / (1000 * 60 * 60 * 24);
  var sla = void 0;

  if (item.eventType === "EVENTSONGROUND") {
    var disp = getDateFormat(item.eventDetails.fromDate) + " " + getTimeFormat(item.eventDetails.fromDate) + "-" + getDateFormat(item.eventDetails.toDate) + " " + getTimeFormat(item.eventDetails.toDate);
    sla =
    // <div style={{ display: "flex" }}>
    //   <Icon name="access-time" action="device" viewBox="0 0 24 24" style={{ height: "20px", width: "35px" }} />
    _react2.default.createElement(_translationNode2.default, { leftWrapperStyle: true, fontSize: 13, color: "rgba(0, 0, 0, 0.60)", label: disp, containerStyle: { marginBottom: 5, marginLeft: -7 } })
    // </div>
    ;
  } else {
    if (days >= 60) sla = _react2.default.createElement(_translationNode2.default, { label: "CS_SLA_MONTH", dynamicArray: [Math.floor(days / 30)], fontSize: 12 });else if (days >= 30) sla = _react2.default.createElement(_translationNode2.default, { label: "CS_SLA_MONTH_ONE", dynamicArray: [Math.floor(days / 30)], fontSize: 12 });else if (days >= 14) sla = _react2.default.createElement(_translationNode2.default, { label: "CS_SLA_WEEK", dynamicArray: [Math.floor(days / 7)], fontSize: 12 });else if (days >= 7) sla = _react2.default.createElement(_translationNode2.default, { label: "CS_SLA_WEEK_ONE", dynamicArray: [Math.floor(days / 7)], fontSize: 12 });else if (days >= 2) sla = _react2.default.createElement(_translationNode2.default, { label: "CS_SLA_DAY", dynamicArray: [Math.floor(days)], fontSize: 12 });else if (days >= 1) sla = _react2.default.createElement(_translationNode2.default, { label: "CS_SLA_DAY_ONE", dynamicArray: [Math.floor(days)], fontSize: 12 });else if (days % 1 * 24 >= 2) sla = _react2.default.createElement(_translationNode2.default, { label: "CS_SLA_TIME", dynamicArray: [Math.floor(days % 1 * 24)], fontSize: 12 });else if (days % 1 * 24 >= 1) sla = _react2.default.createElement(_translationNode2.default, { label: "CS_SLA_TIME_ONE", dynamicArray: [Math.floor(days % 1 * 24)], fontSize: 12 });else if (days % 1 * 24 * 60 >= 2) sla = _react2.default.createElement(_translationNode2.default, { label: "CS_SLA_MINUTE", dynamicArray: [Math.floor(days % 1 * 24 * 60)], fontSize: 12 });else if (days % 1 * 24 * 60 >= 1) sla = _react2.default.createElement(_translationNode2.default, { label: "CS_SLA_MINUTE_ONE", dynamicArray: [Math.floor(days % 1 * 24 * 60)], fontSize: 12 });else sla = _react2.default.createElement(_translationNode2.default, { label: "CS_SLA_NOW", fontSize: 12 });
  }

  return sla;
};

var getEventDate = function getEventDate(eventDate) {
  var month = new Date(eventDate).toString().split(" ")[1].toUpperCase();
  var day = new Date(eventDate).getDate();
  return month + ":" + day;
};
var getReportDay = exports.getReportDay = function getReportDay(ReportDay, ReportConfigCode) {
  var Days = 0;
  var active = false;
  if (ReportDay && ReportDay[0]) {
    ReportDay = ReportDay.filter(function (x) {
      return x.code === ReportConfigCode;
    });
    if (ReportDay && ReportDay[0] && ReportDay[0].active && ReportDay[0].active === true) {
      active = true;
    } else if (ReportDay && ReportDay[0] && ReportDay[0].active && ReportDay[0].active === false) {
      active = false;
    } else if (ReportDay && ReportDay[0] && ReportDay[0].active === undefined) {
      active = true;
    }
    if (active) {
      Days = ReportDay && ReportDay[0] && ReportDay[0].validDay;
    }
  }
  return Days;
};
var setDocuments = function setDocuments(fileUrl) {
  return {
    title: "",
    link: fileUrl && fileUrl.split(",")[0] || "",
    linkText: "View",
    name: decodeURIComponent(fileUrl.split(",")[0].split("?")[0].split("/").pop().slice(13)) || "Document"
  };
};

var getTransformedNotifications = exports.getTransformedNotifications = function () {
  var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(notifications) {
    var data, fileStoreIdArray, fieStoreIdString, _loop, i, fileUrls, finalArray;

    return _regenerator2.default.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            data = [];
            fileStoreIdArray = {};
            fieStoreIdString = [];

            _loop = function _loop() {
              var item = notifications[i];
              if (item.eventDetails && item.eventDetails.documents) {
                item.eventDetails.documents.forEach(function (element) {
                  fieStoreIdString.push(element.fileStoreId);
                  if (!(0, _get2.default)(fileStoreIdArray, item.id)) (0, _set2.default)(fileStoreIdArray, item.id, []);
                  fileStoreIdArray[item.id].push(element.fileStoreId);
                });
              }

              data.push({
                actions: item.actions,
                name: item.name,
                description: item.description,
                eventCategory: item.eventCategory,
                address: item.eventDetails && item.eventDetails.address,
                SLA: item.auditDetails && item.auditDetails.lastModifiedTime && getEventSLA(item),
                buttons: item.actions && item.actions.actionUrls ? item.actions.actionUrls.map(function (actionUrls) {
                  return {
                    label: actionUrls.code,
                    route: getEndpointfromUrl(actionUrls.actionUrl, "redirectTo")
                  };
                }) : [],
                eventDate: item.eventDetails && getEventDate(item.eventDetails.fromDate) || "",
                eventToDate: item.eventDetails && getEventDate(item.eventDetails.toDate) || "",
                type: item.eventType,
                id: item.id,
                tenantId: item.tenantId,
                locationObj: item.eventDetails && { lat: item.eventDetails.latitude || 12.9199988, lng: item.eventDetails.longitude || 77.67078 },
                entryFees: item.eventDetails && item.eventDetails.fees,
                referenceId: item.referenceId
              });
            };

            for (i = 0; i < notifications.length; i++) {
              _loop();
            }
            _context4.next = 7;
            return (0, _commons.getFileUrlFromAPI)(fieStoreIdString.join(","));

          case 7:
            fileUrls = _context4.sent;
            finalArray = data && data.reduce(function (result, item) {
              var doc = (0, _get2.default)(fileStoreIdArray, item.id) && (0, _get2.default)(fileStoreIdArray, item.id).map(function (item, index) {
                return setDocuments((0, _get2.default)(fileUrls, item));
              });
              result.push((0, _extends3.default)({}, item, {
                documents: doc
              }));
              return result;
            }, []);
            return _context4.abrupt("return", finalArray);

          case 10:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, undefined);
  }));

  return function getTransformedNotifications(_x11) {
    return _ref4.apply(this, arguments);
  };
}();

var onNotificationClick = exports.onNotificationClick = function () {
  var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5(history) {
    var permanentCity, queryObject, requestBody;
    return _regenerator2.default.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.prev = 0;
            permanentCity = JSON.parse((0, _localStorageUtils.getUserInfo)()).permanentCity;
            queryObject = [{
              key: "tenantId",
              value: permanentCity ? permanentCity : (0, _localStorageUtils.getTenantId)()
            }];
            requestBody = {
              RequestInfo: {
                apiId: "org.egov.pt",
                ver: "1.0",
                ts: 1502890899493,
                action: "asd",
                did: "4354648646",
                key: "xyz",
                msgId: "654654",
                requesterId: "61",
                authToken: (0, _localStorageUtils.getAccessToken)()
              }
            };
            _context5.next = 6;
            return (0, _api.httpRequest)("/egov-user-event/v1/events/lat/_update", "_update", queryObject, requestBody);

          case 6:
            history.push("/notifications");
            _context5.next = 12;
            break;

          case 9:
            _context5.prev = 9;
            _context5.t0 = _context5["catch"](0);

            (0, _actions2.toggleSnackbarAndSetText)(true, { labelName: "Count update error", labelKey: "Count update error" }, "error");

          case 12:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, undefined, [[0, 9]]);
  }));

  return function onNotificationClick(_x12) {
    return _ref5.apply(this, arguments);
  };
}();

// show toast
var showToast = exports.showToast = function showToast() {
  var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "error";
  var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 5000;

  _store2.default.dispatch((0, _actions2.toggleSnackbarAndSetText)(true, { labelName: message, labelKey: message }, type, duration));
};

var getTotalAmountDue = exports.getTotalAmountDue = function getTotalAmountDue(payload) {
  return payload && payload.Bill && payload.Bill.length > 0 && payload.Bill[0].totalAmount ? payload.Bill[0].totalAmount : 0;
};

var setRoute = exports.setRoute = function setRoute(link) {
  // let moduleName = process.env.REACT_APP_NAME === "Citizen" ? '/citizen' : '/employee';
  // window.location.href =
  //   process.env.NODE_ENV === "production"
  //     ? moduleName + link
  //     : link;

  (0, _formActionUtils.routeTo)(link);
};

var navigateToApplication = exports.navigateToApplication = function navigateToApplication(businessService, propsHistory, applicationNo, tenantId, propertyId) {
  if (businessService == "PT.MUTATION") {
    setRoute("/pt-mutation/search-preview?applicationNumber=" + applicationNo + "&propertyId=" + propertyId + "&tenantId=" + tenantId);
  } else if (businessService == "PT.CREATE") {
    setRoute("/property-tax/application-preview?propertyId=" + propertyId + "&applicationNumber=" + applicationNo + "&tenantId=" + tenantId + "&type=property");
  } else if (businessService == "PT.UPDATE") {
    setRoute("/property-tax/application-preview?propertyId=" + propertyId + "&applicationNumber=" + applicationNo + "&tenantId=" + tenantId + "&type=updateProperty");
  } else if (businessService == "PT.LEGACY") {
    setRoute("/property-tax/application-preview?propertyId=" + propertyId + "&applicationNumber=" + applicationNo + "&tenantId=" + tenantId + "&type=legacy");
  } else {
    setRoute((0, _formUtils.getPropertyInfoScreenUrl)(propertyId, tenantId));
  }
};

var getApplicationType = exports.getApplicationType = function () {
  var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6(applicationNumber, tenantId, creationReason) {
    var queryObject, payload;
    return _regenerator2.default.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            queryObject = [{ key: "businessIds", value: applicationNumber }, { key: "history", value: true }, { key: "tenantId", value: tenantId }];
            _context6.prev = 1;

            if (!creationReason) {
              _context6.next = 22;
              break;
            }

            if (!(creationReason == "MUTATION")) {
              _context6.next = 7;
              break;
            }

            return _context6.abrupt("return", "PT.MUTATION");

          case 7:
            if (!(creationReason == "CREATE")) {
              _context6.next = 11;
              break;
            }

            return _context6.abrupt("return", "PT.CREATE");

          case 11:
            if (!(creationReason == "LEGACY_ENTRY")) {
              _context6.next = 15;
              break;
            }

            return _context6.abrupt("return", "PT.LEGACY");

          case 15:
            if (!(creationReason == "UPDATE")) {
              _context6.next = 19;
              break;
            }

            return _context6.abrupt("return", "PT.UPDATE");

          case 19:
            return _context6.abrupt("return", "NA");

          case 20:
            _context6.next = 27;
            break;

          case 22:
            _context6.next = 24;
            return (0, _api.httpRequest)("egov-workflow-v2/egov-wf/process/_search", "_search", queryObject);

          case 24:
            payload = _context6.sent;

            if (!(payload && payload.ProcessInstances.length > 0)) {
              _context6.next = 27;
              break;
            }

            return _context6.abrupt("return", payload.ProcessInstances[0].businessService);

          case 27:
            _context6.next = 31;
            break;

          case 29:
            _context6.prev = 29;
            _context6.t0 = _context6["catch"](1);

          case 31:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, undefined, [[1, 29]]);
  }));

  return function getApplicationType(_x16, _x17, _x18) {
    return _ref6.apply(this, arguments);
  };
}();

var isDocumentValid = exports.isDocumentValid = function isDocumentValid(docUploaded, requiredDocCount) {
  var totalDocsKeys = Object.keys(docUploaded) || [];
  var isValid = true;
  for (var key = 0; key < totalDocsKeys.length; key++) {
    if (docUploaded[key].isDocumentRequired) {
      if (docUploaded[key].documents && docUploaded[key].dropdown && docUploaded[key].dropdown.value) {
        isValid = true;
      } else {
        isValid = false;
        break;
      }
    } else {
      if (docUploaded[key].documents && (!docUploaded[key].dropdown || !docUploaded[key].dropdown.value)) {
        isValid = false;
        break;
      }
    }
  }
  return isValid;
};

var getMohallaData = exports.getMohallaData = function getMohallaData(payload, tenantId) {
  return payload && payload.TenantBoundary[0] && payload.TenantBoundary[0].boundary && payload.TenantBoundary[0].boundary.reduce(function (result, item) {
    result.push((0, _extends3.default)({}, item, {
      name: tenantId.toUpperCase().replace(/[.]/g, "_") + "_REVENUE_" + item.code.toUpperCase().replace(/[._:-\s\/]/g, "_")
    }));
    return result;
  }, []);
};

var downloadPdf = exports.downloadPdf = function downloadPdf(link) {
  var openIn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "_blank";

  var win = window.open(link, openIn);
  if (win) {
    win.focus();
  }
};

// base 64 data to pdf download
function downloadBase64AsPDF(base64Data, fileName) {
  var byteCharacters = atob(base64Data);
  var byteNumbers = new Array(byteCharacters.length);

  for (var i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }

  var byteArray = new Uint8Array(byteNumbers);
  var blob = new Blob([byteArray], { type: "application/pdf" });

  var link = document.createElement("a");
  link.href = window.URL.createObjectURL(blob);
  link.download = fileName;
  document.body.appendChild(link);

  link.click();

  document.body.removeChild(link);
}

var printPdf = exports.printPdf = function () {
  var _ref7 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee7(link) {
    var response, file, fileURL, myWindow;
    return _regenerator2.default.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.next = 2;
            return _axios2.default.get(link, {
              responseType: "arraybuffer",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/pdf"
              }
            });

          case 2:
            response = _context7.sent;
            file = new Blob([response.data], { type: "application/pdf" });
            fileURL = URL.createObjectURL(file);
            myWindow = window.open(fileURL);

            if (myWindow != undefined) {
              myWindow.addEventListener("load", function (event) {
                myWindow.focus();
                myWindow.print();
              });
            }

          case 7:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7, undefined);
  }));

  return function printPdf(_x20) {
    return _ref7.apply(this, arguments);
  };
}();

var openPdf = exports.openPdf = function () {
  var _ref8 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee8(link) {
    var openIn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "_blank";
    var response, file, fileURL, myWindow;
    return _regenerator2.default.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            if (!(window && window.mSewaApp && window.mSewaApp.isMsewaApp && window.mSewaApp.isMsewaApp())) {
              _context8.next = 4;
              break;
            }

            downloadPdf(link, "_self");
            _context8.next = 11;
            break;

          case 4:
            _context8.next = 6;
            return _axios2.default.get(link, {
              responseType: "arraybuffer",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/pdf"
              }
            });

          case 6:
            response = _context8.sent;
            file = new Blob([response.data], { type: "application/pdf" });
            fileURL = URL.createObjectURL(file);
            myWindow = window.open(fileURL, openIn);

            if (myWindow != undefined) {
              myWindow.addEventListener("load", function (event) {
                myWindow.focus();
              });
            }

          case 11:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8, undefined);
  }));

  return function openPdf(_x21) {
    return _ref8.apply(this, arguments);
  };
}();

var downloadFromLink = exports.downloadFromLink = function () {
  var _ref9 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee9(link) {
    var filename = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "help.pdf";

    var _link;

    return _regenerator2.default.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            if (window && window.mSewaApp && window.mSewaApp.isMsewaApp && window.mSewaApp.isMsewaApp()) {
              downloadPdf(link, "_self");
            } else {
              _link = document.createElement("a");
              // create a blobURI pointing to our Blob

              _link.href = _link;
              _link.download = filename;
              // some browser needs the anchor to be in the doc
              document.body.append(_link);
              _link.click();
              _link.remove();
              // in case the Blob uses a lot of memory
              setTimeout(function () {
                return URL.revokeObjectURL(_link.href);
              }, 7000);
            }

          case 1:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9, undefined);
  }));

  return function downloadFromLink(_x23) {
    return _ref9.apply(this, arguments);
  };
}();

var getModuleName = exports.getModuleName = function getModuleName() {
  var pathName = window.location.pathname;
  if (pathName.indexOf("inbox") > -1) {
    return "rainmaker-common";
  } else if (pathName.indexOf("dss") > -1) {
    return "rainmaker-dss";
  } else if (pathName.indexOf("receipts") > -1) {
    return "rainmaker-receipts";
  } else if (pathName.indexOf("property-tax") > -1 || pathName.indexOf("rainmaker-pt") > -1 || pathName.indexOf("pt-mutation") > -1) {
    return "rainmaker-pt,rainmaker-pgr";
  } else if (pathName.indexOf("pt-common-screens") > -1 || pathName.indexOf("pt-mutation/public-search") > -1) {
    return "rainmaker-pt";
  } else if (pathName.indexOf("complaint") > -1 || pathName.indexOf("pgr") > -1 || pathName.indexOf("resolve-success") > -1 || pathName.indexOf("employee-directory") > -1 || pathName.indexOf("reopen-acknowledgement") > -1 || pathName.indexOf("feedback") > -1 || pathName.indexOf("request-reassign") > -1 || pathName.indexOf("reassign-success") > -1) {
    return "rainmaker-pgr";
  } else if (pathName.indexOf("wns") > -1 || pathName.indexOf("wns/public-search") > -1) {
    return "rainmaker-ws";
  } else if (pathName.indexOf("tradelicense") > -1 || pathName.indexOf("rainmaker-tl") > -1 || pathName.indexOf("tradelicence") > -1 || pathName.indexOf("tradelicense-citizen") > -1) {
    return "rainmaker-tl";
  } else if (pathName.indexOf("hrms") > -1) {
    return "rainmaker-hr";
  } else if (pathName.indexOf("bill-amend") > -1) {
    return "rainmaker-bill-amend,rainmaker-abg";
  } else if (pathName.indexOf("fire-noc") > -1) {
    return "rainmaker-noc,rainmaker-pgr";
  } else if (pathName.indexOf("dss/home") > -1) {
    return "rainmaker-dss";
  } else if (pathName.indexOf("language-selection") > -1) {
    return "rainmaker-common";
  } else if (pathName.indexOf("login") > -1) {
    return "rainmaker-common";
  } else if (pathName.indexOf("pay") > -1) {
    return "rainmaker-noc";
  } else if (pathName.indexOf("abg") > -1) {
    return "rainmaker-abg";
  } else if (pathName.indexOf("bills") > -1) {
    return "rainmaker-ws,rainmaker-abg,rainmaker-bills";
  } else if (pathName.indexOf("uc") > -1) {
    return "rainmaker-uc";
  } else if (pathName.indexOf("pgr-home") > -1 || pathName.indexOf("rainmaker-pgr") > -1) {
    return "rainmaker-pgr";
  } else if (pathName.indexOf("bpastakeholder") > -1 || pathName.indexOf("edcrscrutiny") > -1 || pathName.indexOf("egov-bpa") > -1 || pathName.indexOf("oc-bpa") > -1) {
    return "rainmaker-bpa,rainmaker-bpareg";
  } else if (pathName.indexOf("noc") > -1) {
    return "rainmaker-common-noc";
  } else if (pathName.indexOf("birth") > -1 || pathName.indexOf("death") > -1 || pathName.indexOf("bnd") > -1) {
    return "rainmaker-bnd";
  } else {
    return "rainmaker-common";
  }
};

var businessServiceInfo = exports.businessServiceInfo = function () {
  var _ref10 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee10(mdmsBody, businessService) {
    var payload, businessServiceInfoItem, businessServiceArray;
    return _regenerator2.default.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            _context10.next = 2;
            return (0, _api.httpRequest)("/egov-mdms-service/v1/_search", "_search", [], mdmsBody);

          case 2:
            payload = _context10.sent;
            businessServiceInfoItem = null;
            businessServiceArray = payload.MdmsRes.BillingService.BusinessService;

            businessServiceArray && businessServiceArray.map(function (item) {
              if (item.code == businessService) {
                businessServiceInfoItem = item;
              }
            });
            return _context10.abrupt("return", businessServiceInfoItem);

          case 7:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10, undefined);
  }));

  return function businessServiceInfo(_x25, _x26) {
    return _ref10.apply(this, arguments);
  };
}();

var searchConsumer = exports.searchConsumer = function () {
  var _ref11 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee11(items, queryObject) {
    var payload, consumerDetails;
    return _regenerator2.default.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            _context11.next = 2;
            return (0, _api.httpRequest)("/" + items.fetchConsumerUrl, "_search", queryObject);

          case 2:
            payload = _context11.sent;
            consumerDetails = payload && payload.WaterConnection ? payload.WaterConnection : payload.SewerageConnections;
            return _context11.abrupt("return", consumerDetails);

          case 5:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11, undefined);
  }));

  return function searchConsumer(_x27, _x28) {
    return _ref11.apply(this, arguments);
  };
}();

var fetchConsumerBill = exports.fetchConsumerBill = function () {
  var _ref12 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee12(items, queryObject) {
    var response;
    return _regenerator2.default.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            _context12.next = 2;
            return (0, _api.httpRequest)("/" + items.fecthBillUrl, "_search", queryObject);

          case 2:
            response = _context12.sent;
            return _context12.abrupt("return", response && response.Bill && response.Bill[0]);

          case 4:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12, undefined);
  }));

  return function fetchConsumerBill(_x29, _x30) {
    return _ref12.apply(this, arguments);
  };
}();

var getBusinessServiceMdmsData = exports.getBusinessServiceMdmsData = function () {
  var _ref13 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee13(dispatch, tenantId, businessService) {
    var mdmsBody, businessServiceItem;
    return _regenerator2.default.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            mdmsBody = {
              MdmsCriteria: {
                tenantId: tenantId,
                moduleDetails: [{
                  moduleName: "BillingService",
                  masterDetails: [{ name: "BusinessService" }]
                }]
              }
            };
            _context13.prev = 1;
            _context13.next = 4;
            return businessServiceInfo(mdmsBody, businessService);

          case 4:
            businessServiceItem = _context13.sent;

            dispatch((0, _actions3.prepareFinalObject)("businessServiceInfo", businessServiceItem));
            _context13.next = 10;
            break;

          case 8:
            _context13.prev = 8;
            _context13.t0 = _context13["catch"](1);

          case 10:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13, undefined, [[1, 8]]);
  }));

  return function getBusinessServiceMdmsData(_x31, _x32, _x33) {
    return _ref13.apply(this, arguments);
  };
}();

var getPaymentSearchAPI = exports.getPaymentSearchAPI = function getPaymentSearchAPI() {
  var businessService = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var isCitizenbusinessService = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (businessService == "-1") {
    return "" + _endPoints2.PAYMENTSEARCH.GET.URL + _endPoints2.PAYMENTSEARCH.GET.ACTION;
  } else if (process.env.REACT_APP_NAME === "Citizen" && !isCitizenbusinessService) {
    return "" + _endPoints2.PAYMENTSEARCH.GET.URL + _endPoints2.PAYMENTSEARCH.GET.ACTION;
  }
  return "" + _endPoints2.PAYMENTSEARCH.GET.URL + businessService + "/" + _endPoints2.PAYMENTSEARCH.GET.ACTION;
};

var getFetchBillAPI = exports.getFetchBillAPI = function getFetchBillAPI() {
  return "" + _endPoints2.FETCHBILL.GET.URL;
};

// const userObject=JSON.parse(localStorage.getItem("citizen.userRequestObject"))||{};
// return {user:[userObject]};

var getUserSearchedResponse = exports.getUserSearchedResponse = function getUserSearchedResponse() {
  var userObject = JSON.parse(localStorage.getItem("citizen.userRequestObject")) || {};
  if (process.env.REACT_APP_NAME == "Citizen" && _common2.default.singleInstance) {
    userObject = convertUserForSingleInstance(userObject);
  }
  return { user: [userObject] };
};

var getResultUrl = exports.getResultUrl = function getResultUrl(moduleName, reportName) {
  var reportResultUrl = "/report/" + moduleName + "/" + reportName + "/_get";
  return reportResultUrl;
};
var translate = exports.translate = function translate(locale_text) {
  return locale_text;
};

var downloadWNSBill = exports.downloadWNSBill = function downloadWNSBill(queryObj, fileName) {
  (0, _generatePDF.searchAndDownloadPdf)("/egov-pdf/download/WNS/wnsbill", queryObj, fileName);
};

var printWNSBill = exports.printWNSBill = function printWNSBill(queryObj) {
  (0, _generatePDF.searchAndPrintPdf)("/egov-pdf/download/WNS/wnsbill", queryObj);
};

var wnsBill = function wnsBill(consumerCode, tenantId, service) {
  var query = [{ key: "applicationNumber", value: consumerCode }, { key: "tenantId", value: tenantId }, { key: "bussinessService", value: service }];
  downloadWNSBill(query, service + "-BILL-" + consumerCode + ".pdf");
};

var downloadWNSBillFromConsumer = exports.downloadWNSBillFromConsumer = function () {
  var _ref14 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee14(consumerCode, tenantId, service) {
    var serviceURL, response;
    return _regenerator2.default.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            serviceURL = service == "WS" ? "ws-services/wc/_search" : "sw-services/swc/_search";
            _context14.next = 3;
            return (0, _api2.httpRequest)("post", serviceURL + "?tenantId=" + tenantId + "&isConnectionSearch=true&connectionNumber=" + consumerCode, "_search", [], {});

          case 3:
            response = _context14.sent;

            if (response && response.WaterConnection && response.WaterConnection.length > 0) {
              wnsBill(response.WaterConnection[0].applicationNo, tenantId, service);
            } else if (response && response.SewerageConnections && response.SewerageConnections.length > 0) {
              wnsBill(response.SewerageConnections[0].applicationNo, tenantId, service);
            }

          case 5:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14, undefined);
  }));

  return function downloadWNSBillFromConsumer(_x36, _x37, _x38) {
    return _ref14.apply(this, arguments);
  };
}();

/* TO CONVERT USER TO CENTRAL INSTANCE */
var convertUserForSingleInstance = exports.convertUserForSingleInstance = function convertUserForSingleInstance() {
  var user = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var tenantId = _common2.default.tenantId;
  localStorage.setItem("Citizen.tenant-id", tenantId);
  localStorage.setItem("tenant-id", tenantId);
  user.tenantId = tenantId;
  return (0, _extends3.default)({}, user);
};

var transformComplaintForComponentUpdate = exports.transformComplaintForComponentUpdate = function transformComplaintForComponentUpdate(complaints, role, employeeById, citizenById, categoriesById, displayStatus) {
  var defaultPhoneNumber = "";
  var transformedComplaints = Object.values(complaints.byId).map(function (complaintDetail, index) {
    var filedUserName = complaintDetail && complaintDetail.citizen && complaintDetail.citizen.name;
    var isFiledByCSR = complaintDetail && complaintDetail.actions && complaintDetail.actions[complaintDetail.actions.length - 1].by && complaintDetail.actions[complaintDetail.actions.length - 1].by.split(":")[1] && complaintDetail.actions[complaintDetail.actions.length - 1].by.split(":")[1] === "Citizen Service Representative";
    return {
      header: getPropertyFromObj(complaints.categoriesById, complaintDetail.serviceCode, "serviceCode", "" + complaintDetail.serviceCode),
      date: complaintDetail.auditDetails.createdTime,
      category: complaintDetail.category,
      latestCreationTime: getLatestCreationTime(complaintDetail),
      complaintNo: complaintDetail.serviceRequestId,
      source: complaintDetail.source && complaintDetail.source,
      images: fetchImages(complaintDetail.actions).filter(function (imageSource) {
        // isImage(imageSource);
        return true;
      }),
      complaintStatus: complaintDetail.status && getTransformedStatus(complaintDetail.status),
      rawStatus: complaintDetail.status && complaintDetail.status,
      servicetype: complaintDetail.servicetype && complaintDetail.servicetype,
      prevDept: complaintDetail.prevDept && complaintDetail.prevDept,
      address: complaintDetail.address ? complaintDetail.address : "",
      addressDetail: complaintDetail.addressDetail ? complaintDetail.addressDetail : {},
      reassign: complaintDetail.status === "reassignrequested" ? true : false,
      reassignRequestedBy: complaintDetail.status === "reassignrequested" ? getPropertyFromObj(employeeById, complaintDetail.actions[0].by.split(":")[0], "name", "NA") : "NA",
      latestActionTime: complaintDetail && complaintDetail.actions && getLatestAction(complaintDetail.actions),
      //
      submittedBy: filedUserName ? isFiledByCSR ? filedUserName + " (Citizen Service Desk)" : filedUserName : "NA",
      citizenPhoneNumber: complaintDetail && complaintDetail.citizen && complaintDetail.citizen.mobileNumber,
      assignedTo: complaintDetail && getPropertyFromObj(employeeById, findLatestAssigneeUpdate(complaintDetail.actions), "name", "NA"),
      // no need
      employeePhoneNumber: employeeById && employeeById[findLatestAssigneeUpdate(complaintDetail.actions)] ? employeeById[findLatestAssigneeUpdate(complaintDetail.actions)].mobileNumber : defaultPhoneNumber,
      status: role === "citizen" ? displayStatus(complaintDetail.status, complaintDetail.assignee, complaintDetail.actions.filter(function (complaint) {
        return complaint.status;
      })[0].action) : getTransformedStatus(complaintDetail.status) === "CLOSED" ? complaintDetail.rating ? displayStatus(complaintDetail.rating + "/5") : displayStatus(complaintDetail.actions[0].status) : displayStatus(returnSLAStatus(getPropertyFromObj(categoriesById, complaintDetail.serviceCode, "slaHours", 0), getLatestCreationTime(complaintDetail)).slaStatement),
      SLA: returnSLAStatus(getPropertyFromObj(categoriesById, complaintDetail.serviceCode, "slaHours", 0), getLatestCreationTime(complaintDetail)).daysCount
    };
  });
  var assignedTotalComplaints = transformedComplaints.filter(function (x) {
    return x.complaintStatus === "ASSIGNED";
  });
  var unassignedTotalComplaints = transformedComplaints.filter(function (x) {
    return x.complaintStatus === "UNASSIGNED";
  });
  window.localStorage.setItem("assignedTotalComplaints", assignedTotalComplaints && assignedTotalComplaints.length);
  window.localStorage.setItem("unassignedTotalComplaints", unassignedTotalComplaints && unassignedTotalComplaints.length);

  return transformedComplaints;
};

var styles = exports.styles = {
  headerInCodegen: { color: "#3f3a9c", fontSize: "17px", padding: "0px 16px", textAlign: "left", fontWeight: "500" },
  searchButtonCodegen: {
    width: "17%",
    marginRight: "10px",
    marginLeft: "10px",
    textAlign: "end",
    height: "4.3rem",
    boxShadow: "none",
    textTransform: "none",
    fontSize: 12,
    padding: "6px 12px",
    border: "1px solid",
    lineHeight: 1.5,
    backgroundColor: "#2b2592e6",
    borderColor: "#2b2592e6"
  },
  searchButtonCodegenDisabled: {
    width: "17%",
    marginRight: "10px",
    marginLeft: "10px",
    textAlign: "end",
    height: "4.3rem",
    boxShadow: "none",
    textTransform: "none",
    fontSize: 12,
    padding: "6px 12px",
    border: "1px solid",
    lineHeight: 1.5,
    backgroundColor: "#D3D3D3",
    color: "#808080",
    cursor: "not-allowed",
    opacity: 0.6
  },
  resetButtonCodegen: {
    width: "17%",
    marginLeft: "10px",
    marginRight: "10px",
    height: "4.3rem",
    boxShadow: "none",
    textTransform: "none",
    fontSize: 12,
    padding: "6px 12px",
    border: "1px solid",
    lineHeight: 1.5,
    backgroundColor: "transparent",
    borderColor: "#2b2592e6",
    color: "#2b2592e6"
  },
  resetButtonCodegenWithMargin: {
    width: "17%",
    height: "4.3rem",
    boxShadow: "none",
    textTransform: "none",
    fontSize: 12,
    padding: "6px 12px",
    border: "1px solid",
    lineHeight: 1.5,
    backgroundColor: "transparent",
    borderColor: "#2b2592e6",
    color: "#2b2592e6"
  },
  root: { width: "100%" },
  formControl: { width: "84%" },
  priceSize: {
    color: "#474386",
    fontWeight: "500"
  },
  headerDesignFooter: {
    fontSize: "13px",
    fontWeight: "bold",
    color: "#413aab"
  },
  spanDesign: {
    padding: "0px 30px",
    color: "#6f6a6a",
    fontWeight: "bold"
  },
  headerStyle: { paddingLeft: "30px", paddingTop: "17px" },
  header_modal: {
    width: "28%",
    fontSize: "16px",
    padding: "16px 3px 5px 0px",
    letterSpacing: "1px",
    fontWeight: "500",
    color: " #474386",
    borderBottom: " 3px solid #e3b40f",
    marginLeft: "24px"
  },
  cardComponent: {
    backgroundColor: "#eee",
    boxShadow: "none"
  },
  buttonContainer: (_buttonContainer = {
    backgroundColor: "white",
    position: "fixed",
    height: "69px",
    padding: "12px",
    bottom: "0px",
    display: "inline"
  }, (0, _defineProperty3.default)(_buttonContainer, "padding", "11px"), (0, _defineProperty3.default)(_buttonContainer, "textAlign", "right"), (0, _defineProperty3.default)(_buttonContainer, "borderRadius", "4px"), (0, _defineProperty3.default)(_buttonContainer, "zIndex", 1), (0, _defineProperty3.default)(_buttonContainer, "boxShadow", "0 -2px 4px 0 rgb(0 0 0 / 24%)"), (0, _defineProperty3.default)(_buttonContainer, "width", "100%"), (0, _defineProperty3.default)(_buttonContainer, "left", "0%"), (0, _defineProperty3.default)(_buttonContainer, "overflow", "inherit"), _buttonContainer),
  previousButton: {
    maxWidth: "171px",
    border: "1px solid rgb(254, 122, 81)",
    backgroundColor: "#fff",
    color: "rgb(254, 122, 81)",
    padding: "14px 66px",
    borderRadius: "2px",
    margin: "0px 10px",
    boxShadow: "0px 1px 5px 0px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 3px 1px -2px rgb(0 0 0 / 12%);"
  },
  submitButton: {
    maxWidth: "171px",
    backgroundColor: "rgb(254, 122, 81)",
    padding: "14px 72px",
    margin: "0px 10px",
    color: "#fff",
    borderRadius: "2px",
    boxShadow: "0px 1px 5px 0px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 3px 1px -2px rgb(0 0 0 / 12%);"
  },
  autoSuggestDD: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  saveAsDraftButton: {
    maxWidth: "171px",
    backgroundColor: "rgb(254, 122, 81)",
    padding: "14px 19px",
    margin: "0px 10px",
    color: "#fff",
    borderRadius: "2px",
    boxShadow: "0px 1px 5px 0px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 3px 1px -2px rgb(0 0 0 / 12%);"
  },
  labelStyle: {
    letterSpacing: "0.67px",
    color: "rgba(0, 0, 0, 0.87)",
    fontWeight: "400",
    lineHeight: "19px"
  },
  subHeaderStyle: (0, _defineProperty3.default)({
    letterSpacing: "0.67px",
    color: "rgba(0, 0, 0, 0.87)",
    fontWeight: "500",
    lineHeight: "19px",
    fontSize: "17px"
  }, "color", "peru"),
  cardChildren: {
    alignItems: "center",
    marginLeft: "13px",
    justifyContent: "space-between"
  },
  header: {
    width: "14%",
    fontSize: "14px",
    padding: "16px 3px 5px 0px",
    letterSpacing: "1px",
    fontWeight: "500",
    color: " #474386",
    borderBottom: " 3px solid #e3b40f",
    marginLeft: "24px"
  },
  headerLg: {
    width: "17%",
    fontSize: "14px",
    padding: "16px 3px 5px 0px",
    letterSpacing: "1px",
    fontWeight: "500",
    color: " #474386",
    borderBottom: " 3px solid #e3b40f",
    marginLeft: "24px"
  },
  addButton: { padding: "9px 12px" },
  lableStyle: {
    fontWeight: "600",
    color: "#fe7a51"
  },
  textField: { width: "84%" },
  textField_modal: {
    width: "91%"
  },
  card: {
    margin: "15px 19px",
    height: "auto",
    width: "unset",
    display: "block"
  },
  EmpFormControl: {
    width: "253px"
  },
  table: { minWidth: 1020 },
  tableCard: { margin: "0px 19px" },
  tableHeader: {
    color: "#373191",
    fontWeight: "500",
    fontSize: "16px"
  },
  searchButton: {
    width: "35%",
    marginRight: "10px",
    textAlign: "end",
    height: "4.3rem",
    boxShadow: "none",
    textTransform: "none",
    fontSize: 12,
    padding: "6px 12px",
    border: "1px solid",
    lineHeight: 1.5,
    backgroundColor: "#2b2592e6",
    borderColor: "#2b2592e6"
  },
  resetButton: {
    width: "35%",
    marginLeft: "10px",
    height: "4.3rem",
    boxShadow: "none",
    textTransform: "none",
    fontSize: 12,
    padding: "6px 12px",
    border: "1px solid",
    lineHeight: 1.5,
    backgroundColor: "transparent",
    borderColor: "#2b2592e6",
    color: "#2b2592e6"
  },
  tableWrapper: { overflowX: "auto" },
  acceptButton: { fontWeight: 600, color: "rgb(22 159 80)", backgroundColor: "rgb(0 0 0 / 15%)" },
  objectionButton: { color: "#CA6F1E", backgroundColor: "rgba(0, 0, 0, 0.08)" },
  noResponseButton: { color: "#D4AC0D", backgroundColor: "rgba(0, 0, 0, 0.08)" },
  assesseeButton: { color: "white", backgroundColor: "rgb(14 153 51)" },
  inspectorButton: { color: "white", backgroundColor: "#3284cd" },
  hearingButton: { color: "white", backgroundColor: "rgb(173 182 31)" },
  disabledButton: { color: "white", backgroundColor: "rgb(179 185 190)" },
  adjournButton: { color: "white", backgroundColor: "#59beda" },
  decisionButton: { color: "white", backgroundColor: "rgb(74 150 33)" },
  rescheduleButton: { color: "white", backgroundColor: "rgb(74 150 33)" },
  scheduleButton: { color: "white", backgroundColor: "rgb(74 150 33)" },
  safCard: {
    margin: "1rem 2rem 2rem",
    height: "auto",
    width: "unset",
    display: "block",
    padding: "14px 19px"
  },
  ptFooter: (_ptFooter = {
    backgroundColor: "white",
    position: "fixed",
    height: "69px",
    padding: "12px",
    bottom: "0px",
    display: "inline"
  }, (0, _defineProperty3.default)(_ptFooter, "padding", "11px"), (0, _defineProperty3.default)(_ptFooter, "textAlign", "right"), (0, _defineProperty3.default)(_ptFooter, "borderRadius", "4px"), (0, _defineProperty3.default)(_ptFooter, "zIndex", 1), (0, _defineProperty3.default)(_ptFooter, "boxShadow", "0 -2px 4px 0 rgb(0 0 0 / 24%)"), (0, _defineProperty3.default)(_ptFooter, "width", "100%"), (0, _defineProperty3.default)(_ptFooter, "left", "0%"), (0, _defineProperty3.default)(_ptFooter, "overflow", "inherit"), _ptFooter),
  dialogSaveButton: {
    width: "17%",
    marginRight: "15px",
    marginTop: "20px",
    textAlign: "end",
    height: "4rem",
    boxShadow: "none",
    textTransform: "none",
    fontSize: 16,
    padding: "6px 12px",
    border: "1px solid",
    lineHeight: 1.5,
    backgroundColor: "#2b2592e6",
    borderColor: "#2b2592e6"
  },
  dialogCloseButton: {
    width: "17%",
    marginRight: "15px",
    marginTop: "20px",
    textAlign: "end",
    height: "4rem",
    boxShadow: "none",
    textTransform: "none",
    fontSize: 16,
    padding: "6px 12px",
    border: "1px solid",
    lineHeight: 1.5,
    backgroundColor: "#fff",
    borderColor: "#2b2592e6",
    color: "rgba(43, 37, 146, 0.9)"
  },
  buttonStyles: {
    backgroundColor: "rgb(61, 55, 162)",
    padding: "14px 72px",
    margin: "0px 10px",
    color: "#fff",
    borderRadius: "2px",
    boxShadow: "0px 1px 5px 0px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 3px 1px -2px rgb(0 0 0 / 12%)"
  }
};

//   check whether all keys present or not in array of object
var areAllValuesPresent = exports.areAllValuesPresent = function areAllValuesPresent(object) {
  var valuesExist = object.every(function (obj) {
    return Object.values(obj).every(function (val) {
      return Boolean(val);
    });
  });
  return valuesExist;
};

// check whether provided keys are presented in the object or not
var areProvidedObjectKeysPresent = exports.areProvidedObjectKeysPresent = function areProvidedObjectKeysPresent(obj, keys) {
  return keys.every(function (key) {
    return obj[key] !== "" && obj[key] !== undefined && obj[key] !== null;
  });
};

// check all the value of an array of object is present or not
var areAllValuesPresentInArray = exports.areAllValuesPresentInArray = function areAllValuesPresentInArray(array) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = array[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var obj = _step.value;

      // Iterate through the keys of each object
      for (var key in obj) {
        if (obj[key] === undefined || obj[key] === null || obj[key] === "") {
          return false; // If any value is missing, return false
        }
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return true; // All values are present
};

// check whether the value of owner in master exist or not
var areAllValuesPresentInOwnerArray = exports.areAllValuesPresentInOwnerArray = function areAllValuesPresentInOwnerArray(array) {
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = array[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var obj = _step2.value;

      // Iterate through the keys of each object
      for (var key in obj) {
        if (obj.hasOwnProperty("ownerInfoUuid")) {
          if (obj[key] === undefined || obj[key] === null || obj[key] === "") {
            return false; // If any value is missing, return false
          }
        }
      }
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  return true; // All values are present
};

//   check whether all keys present or not in object
var areAllValuesPresentInObject = exports.areAllValuesPresentInObject = function areAllValuesPresentInObject(object) {
  var status = Object.values(object).every(function (value) {
    return value !== undefined && value !== "";
  });
  return status;
};

// check at least one value present in an object or not
var atLeastOneValuePresent = exports.atLeastOneValuePresent = function atLeastOneValuePresent(obj) {
  // Convert object values to an array
  var valuesArray = Object.values(obj);
  // Check if at least one value is present in the array
  var status = valuesArray.some(function (value) {
    return value !== null && value !== undefined && value !== "";
  });
  return status;
};

// common helper to show saf respective buttons
var showSafButtons = exports.showSafButtons = function showSafButtons(safStatus) {
  //      MASTER/SAVE/SUBMIT (Assessee Version)
  //      IN_SUBMIT/ IN_SAVE /IN_FINAL(Inspector Version)
  // 	  HR_FINAL HR_SAVE  HR_SUBMIT (Hearing Officer Version)

  if (safStatus === "Master") {
    return "assessee";
  } else if (safStatus === "IN_SUBMIT" || safStatus === "IN_FINAL") {
    return "inspector";
  } else if (safStatus === "HR_FINAL" || safStatus === "HR_SAVE" || safStatus === "HR_SUBMIT") {
    return "hearing";
  }
};

//set the url and success message for saf submission
var safSubmitMessage = exports.safSubmitMessage = function safSubmitMessage(type) {
  var url = void 0,
      successMessage = void 0;

  var version = (0, _get2.default)(_store2.default.getState().screenConfiguration, "preparedFinalObject.saf.version", {});

  if (version == "assessee" && type == "submit") {
    url = "/property-services/assessment/_uaaInsertUpdateFormat?operationType=SUBMIT";
    successMessage = "SAF details Submitted Successfully!";
  } else if (version == "assessee" && type == "save") {
    url = "/property-services/assessment/_uaaInsertUpdateFormat?operationType=SAVE";
    successMessage = "SAF details saved Successfully!";
  } else if (version == "inspector" && type == "submit") {
    url = "/property-services/assessment/_uaaInsertUpdateFormat?operationType=IN_SUBMIT";
    successMessage = "SAF details Submitted Successfully for inspector!";
  } else if (version == "inspector" && type == "save") {
    url = "/property-services/assessment/_uaaInsertUpdateFormat?operationType=IN_SAVE";
    successMessage = "SAF details saved Successfully for inspector!";
  } else if (version == "hearing" && type == "save") {
    url = "/property-services/assessment/_uaaInsertUpdateFormat?operationType=HR_SAVE";
    successMessage = "SAF hearing details saved Successfully!";
  } else if (version == "hearing" && type == "submit") {
    url = "/property-services/assessment/_uaaInsertUpdateFormat?operationType=HR_SUBMIT";
    successMessage = "SAF hearing details saved Successfully!";
  }
  return { url: url, successMessage: successMessage };
};

//get streetList based On selected ward
var fetchStreetName = exports.fetchStreetName = function () {
  var _ref15 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee15(wardNo, toggleSnackbarAndSetText) {
    var response, streetList, message;
    return _regenerator2.default.wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            _context15.prev = 0;
            _context15.next = 3;
            return (0, _api.httpRequestForPT)("/property-services/common/_streetMaster?wardNo=" + wardNo, "", []);

          case 3:
            response = _context15.sent;

            if (!(response.tokenStatus === "invalid")) {
              _context15.next = 9;
              break;
            }

            toggleSnackbarAndSetText(true, {
              labelName: "Invalid Access Token. Please login again",
              labelKey: "Invalid Access Token. Please login again"
            }, "error");
            return _context15.abrupt("return", null);

          case 9:
            if (!(response.tokenStatus === "valid" && (response.status === 200 || response.status === 201))) {
              _context15.next = 15;
              break;
            }

            streetList = response.data.data.map(function (street) {
              return {
                label: street.street + " - " + street.streetName,
                value: street.street
              };
            });

            streetList.push({ label: "Others", value: "0" });
            return _context15.abrupt("return", streetList);

          case 15:
            message = response.data.hasOwnProperty("Errors") && response.data.Errors && response.data.Errors.length > 0 && response.data.Errors[0].message;

            toggleSnackbarAndSetText(true, {
              labelName: message,
              labelKey: message
            }, "error");
            return _context15.abrupt("return", null);

          case 18:
            _context15.next = 24;
            break;

          case 20:
            _context15.prev = 20;
            _context15.t0 = _context15["catch"](0);

            console.error(_context15.t0);
            return _context15.abrupt("return", null);

          case 24:
          case "end":
            return _context15.stop();
        }
      }
    }, _callee15, undefined, [[0, 20]]);
  }));

  return function fetchStreetName(_x40, _x41) {
    return _ref15.apply(this, arguments);
  };
}();

// get ward list on page load
var getWardList = exports.getWardList = function () {
  var _ref16 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee16() {
    var mdmsBody, response, wardData, wardList;
    return _regenerator2.default.wrap(function _callee16$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            _context16.prev = 0;
            mdmsBody = {
              MdmsCriteria: {
                tenantId: "km",
                moduleDetails: [{ moduleName: "PropertyTax", masterDetails: [{ name: "ward" }] }]
              }
            };
            _context16.next = 4;
            return (0, _api.httpRequestForPT)(_PTServiceUrls.urlMDMSSearch, "", [], mdmsBody);

          case 4:
            response = _context16.sent;

            if (!(response.tokenStatus === "invalid")) {
              _context16.next = 9;
              break;
            }

            showToast("Invalid Access Token. Please login again", "error");
            _context16.next = 19;
            break;

          case 9:
            if (!(response.tokenStatus === "valid" && [200, 201].includes(response.status))) {
              _context16.next = 16;
              break;
            }

            if (!(response.data.MdmsRes && response.data.MdmsRes.PropertyTax)) {
              _context16.next = 14;
              break;
            }

            wardData = response.data.MdmsRes.PropertyTax.ward, wardList = [{ value: "", label: "Select" }];


            wardData.map(function (_ref17) {
              var name = _ref17.name,
                  code = _ref17.code;

              wardList.push({ label: name, value: code });
              return wardList;
            });
            return _context16.abrupt("return", wardList);

          case 14:
            _context16.next = 19;
            break;

          case 16:
            if (!(response.data.hasOwnProperty("Errors") && response.data.Errors && response.data.Errors.length > 0 && response.data.Errors[0].message)) {
              _context16.next = 19;
              break;
            }

            showToast(response.data.Errors[0].message, "error");
            return _context16.abrupt("return", []);

          case 19:
            _context16.next = 24;
            break;

          case 21:
            _context16.prev = 21;
            _context16.t0 = _context16["catch"](0);

            showToast(_context16.t0.message, "error");

          case 24:
          case "end":
            return _context16.stop();
        }
      }
    }, _callee16, undefined, [[0, 21]]);
  }));

  return function getWardList() {
    return _ref16.apply(this, arguments);
  };
}();

// get ward list from office code
var getWardListFromOfficeCode = exports.getWardListFromOfficeCode = function () {
  var _ref18 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee17() {
    var officeCode, wardList, requestBody, response, wardData, message;
    return _regenerator2.default.wrap(function _callee17$(_context17) {
      while (1) {
        switch (_context17.prev = _context17.next) {
          case 0:
            officeCode = localStorage.getItem("officeId");
            wardList = [{ value: "", label: "Select" }];
            requestBody = {
              MdmsCriteria: {
                moduleDetails: [{
                  moduleName: "PropertyTax",
                  masterDetails: [{
                    name: "WARD_LIST",
                    filter: "",
                    moduleCode: "ASMT",
                    officeCode: officeCode
                  }]
                }]
              }
            };
            _context17.prev = 3;
            _context17.next = 6;
            return (0, _api.httpRequestForPT)(_PTServiceUrls.urlFormatSAFTableDropDown, "", [], requestBody, [], {}, true);

          case 6:
            response = _context17.sent;

            if (!(response.tokenStatus == "invalid")) {
              _context17.next = 12;
              break;
            }

            showToast("Invalid Access Token. Please login again", "warning");
            return _context17.abrupt("return", []);

          case 12:
            if (!(response.tokenStatus == "valid" && (response.status == 200 || response.status == 201))) {
              _context17.next = 18;
              break;
            }

            wardData = response.data.data.PropertyTax;

            wardData && wardData.WARD_LIST && wardData.WARD_LIST.length > 0 && wardData.WARD_LIST.map(function (_ref19) {
              var name = _ref19.name,
                  code = _ref19.code;

              wardList.push({ label: name, value: code });
            });
            return _context17.abrupt("return", wardList);

          case 18:
            message = response.data.hasOwnProperty("Errors") && response.data.Errors && response.data.Errors.length > 0 && response.data.Errors[0].message;

            showToast(message, "error");
            return _context17.abrupt("return", []);

          case 21:
            _context17.next = 27;
            break;

          case 23:
            _context17.prev = 23;
            _context17.t0 = _context17["catch"](3);

            showToast(_context17.t0.message, "error");
            return _context17.abrupt("return", []);

          case 27:
          case "end":
            return _context17.stop();
        }
      }
    }, _callee17, undefined, [[3, 23]]);
  }));

  return function getWardListFromOfficeCode() {
    return _ref18.apply(this, arguments);
  };
}();

// call api for street list
var getStreetListOnWardChange = exports.getStreetListOnWardChange = function () {
  var _ref20 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee18(wardNo) {
    var response, streetList, message;
    return _regenerator2.default.wrap(function _callee18$(_context18) {
      while (1) {
        switch (_context18.prev = _context18.next) {
          case 0:
            _context18.prev = 0;
            _context18.next = 3;
            return (0, _api.httpRequestForPT)("/property-services/common/_streetMaster?wardNo=" + wardNo, "", []);

          case 3:
            response = _context18.sent;

            if (!(response.tokenStatus === "invalid")) {
              _context18.next = 9;
              break;
            }

            showToast("Invalid Access Token. Please login again", "error");
            return _context18.abrupt("return", []);

          case 9:
            if (!(response.tokenStatus === "valid" && [200, 201].includes(response.status))) {
              _context18.next = 16;
              break;
            }

            streetList = [];

            streetList = response.data.data.map(function (_ref21) {
              var streetName = _ref21.streetName,
                  street = _ref21.street;
              return {
                label: street + " - " + streetName,
                value: street
              };
            });
            streetList.push({ label: "Others", value: "0" });

            return _context18.abrupt("return", streetList);

          case 16:
            message = response.data.hasOwnProperty("Errors") && response.data.Errors.length > 0 && response.data.Errors[0].message;

            showToast(message, "error");
            return _context18.abrupt("return", []);

          case 19:
            _context18.next = 24;
            break;

          case 21:
            _context18.prev = 21;
            _context18.t0 = _context18["catch"](0);

            showToast(_context18.t0.message, "error");

          case 24:
          case "end":
            return _context18.stop();
        }
      }
    }, _callee18, undefined, [[0, 21]]);
  }));

  return function getStreetListOnWardChange(_x42) {
    return _ref20.apply(this, arguments);
  };
}();

// get ward list on page load
var getWardListForHearingAdmin = exports.getWardListForHearingAdmin = function () {
  var _ref22 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee19() {
    var empId, wardList, requestBody, response, wardData, message;
    return _regenerator2.default.wrap(function _callee19$(_context19) {
      while (1) {
        switch (_context19.prev = _context19.next) {
          case 0:
            empId = JSON.parse(localStorage.getItem("user-info")).userName;
            wardList = [{ value: "", label: "Select" }];
            requestBody = {
              requestData: { purpose: "UAA_HEARING_ADMIN", empId: empId }
            };
            _context19.prev = 3;
            _context19.next = 6;
            return (0, _api.httpRequestForPT)(_PTServiceUrls.urlSAFFetchUserPermissibleWardList, "", [], requestBody, [], {}, true);

          case 6:
            response = _context19.sent;

            if (!(response.tokenStatus == "invalid")) {
              _context19.next = 12;
              break;
            }

            showToast("Invalid Access Token. Please login again", "warning");
            return _context19.abrupt("return", []);

          case 12:
            if (!(response.tokenStatus == "valid" && (response.status == 200 || response.status == 201))) {
              _context19.next = 18;
              break;
            }

            wardData = response.data.data;

            wardData.map(function (w) {
              wardList.push({
                label: w,
                value: w
              });
            });
            return _context19.abrupt("return", wardList);

          case 18:
            message = response.data.hasOwnProperty("Errors") && response.data.Errors && response.data.Errors.length > 0 && response.data.Errors[0].message;

            showToast(message, "error");
            return _context19.abrupt("return", []);

          case 21:
            _context19.next = 27;
            break;

          case 23:
            _context19.prev = 23;
            _context19.t0 = _context19["catch"](3);

            showToast(_context19.t0.message, "error");
            return _context19.abrupt("return", []);

          case 27:
          case "end":
            return _context19.stop();
        }
      }
    }, _callee19, undefined, [[3, 23]]);
  }));

  return function getWardListForHearingAdmin() {
    return _ref22.apply(this, arguments);
  };
}();

var getWardListForTaxInspector = exports.getWardListForTaxInspector = function () {
  var _ref23 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee20() {
    var empId, wardList, requestBody, response, wardData, message;
    return _regenerator2.default.wrap(function _callee20$(_context20) {
      while (1) {
        switch (_context20.prev = _context20.next) {
          case 0:
            empId = JSON.parse(localStorage.getItem("user-info")).id;
            wardList = [{ value: "", label: "Select" }];
            requestBody = {
              requestData: { purpose: "UAA_INSPECTION", empId: empId }
            };
            _context20.prev = 3;
            _context20.next = 6;
            return (0, _api.httpRequestForPT)(_PTServiceUrls.urlSAFFetchUserPermissibleWardList, "", [], requestBody, [], {}, true);

          case 6:
            response = _context20.sent;

            if (!(response.tokenStatus == "invalid")) {
              _context20.next = 12;
              break;
            }

            showToast("Invalid Access Token. Please login again", "warning");
            return _context20.abrupt("return", []);

          case 12:
            if (!(response.tokenStatus == "valid" && (response.status == 200 || response.status == 201))) {
              _context20.next = 18;
              break;
            }

            wardData = response.data.data;

            wardData.map(function (w) {
              wardList.push({
                name: w,
                code: w,
                label: w,
                value: w
              });
            });
            return _context20.abrupt("return", wardList);

          case 18:
            message = response.data.hasOwnProperty("Errors") && response.data.Errors && response.data.Errors.length > 0 && response.data.Errors[0].message;

            showToast(message, "error");
            return _context20.abrupt("return", []);

          case 21:
            _context20.next = 27;
            break;

          case 23:
            _context20.prev = 23;
            _context20.t0 = _context20["catch"](3);

            showToast(_context20.t0.message, "error");
            return _context20.abrupt("return", []);

          case 27:
          case "end":
            return _context20.stop();
        }
      }
    }, _callee20, undefined, [[3, 23]]);
  }));

  return function getWardListForTaxInspector() {
    return _ref23.apply(this, arguments);
  };
}();

// get hearing officer list
var getHearingOfficer = exports.getHearingOfficer = function () {
  var _ref24 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee21(wardNo) {
    var officerList, requestBody, response, officerData, message;
    return _regenerator2.default.wrap(function _callee21$(_context21) {
      while (1) {
        switch (_context21.prev = _context21.next) {
          case 0:
            officerList = [{ value: "", label: "Select" }];
            requestBody = {
              requestData: { purpose: "UAA_HEARING_OFFICER", wardNo: wardNo }
            };
            _context21.prev = 2;
            _context21.next = 5;
            return (0, _api.httpRequestForPT)(_PTServiceUrls.urlSAFFetchHearingOfficerList, "", [], requestBody, [], {}, true);

          case 5:
            response = _context21.sent;

            if (!(response.tokenStatus == "invalid")) {
              _context21.next = 11;
              break;
            }

            showToast("Invalid Access Token. Please login again", "warning");
            return _context21.abrupt("return", []);

          case 11:
            if (!(response.tokenStatus == "valid" && (response.status == 200 || response.status == 201))) {
              _context21.next = 17;
              break;
            }

            officerData = response.data.data;

            officerData.map(function (w) {
              officerList.push({
                name: w.empName,
                code: w.empId,
                label: w.empName,
                value: w.empId
              });
            });
            return _context21.abrupt("return", officerList);

          case 17:
            message = response.data.hasOwnProperty("Errors") && response.data.Errors && response.data.Errors.length > 0 && response.data.Errors[0].message;

            showToast(message, "error");
            return _context21.abrupt("return", []);

          case 20:
            _context21.next = 26;
            break;

          case 22:
            _context21.prev = 22;
            _context21.t0 = _context21["catch"](2);

            showToast(_context21.t0.message, "error");
            return _context21.abrupt("return", []);

          case 26:
          case "end":
            return _context21.stop();
        }
      }
    }, _callee21, undefined, [[2, 22]]);
  }));

  return function getHearingOfficer(_x43) {
    return _ref24.apply(this, arguments);
  };
}();

// check whether at least any value presetnt on the object or not
var atLeastOneValuesPresentInObject = exports.atLeastOneValuesPresentInObject = function atLeastOneValuesPresentInObject(obj) {
  var hasValue = Object.keys(obj).some(function (key) {
    return obj[key] !== null && obj[key] !== undefined && obj[key] !== "";
  });
  return hasValue;
};

// format qurter
var formatQuarter = exports.formatQuarter = function formatQuarter(qtrNumber) {
  var stringQtrNumber = qtrNumber.toString();
  var formatNumber = +stringQtrNumber.slice(4) + "/" + stringQtrNumber.slice(0, 4);
  return formatNumber;
};

var getSearchResults = exports.getSearchResults = function () {
  var _ref25 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee22(queryObject, requestBody) {
    var searchURL = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "/property-services/property/_search";
    var response;
    return _regenerator2.default.wrap(function _callee22$(_context22) {
      while (1) {
        switch (_context22.prev = _context22.next) {
          case 0:
            _context22.prev = 0;

            _store2.default.dispatch(toggleSpinner());
            _context22.next = 4;
            return (0, _api.httpRequest)("post", searchURL, "", queryObject, requestBody);

          case 4:
            response = _context22.sent;

            response && response.Properties && response.Properties.map(function (property) {
              var newOwnerList = [];
              var oldOwnerList = [];
              property.owners.map(function (owner) {
                if (owner.status == "ACTIVE") {
                  newOwnerList.push(owner);
                } else {
                  oldOwnerList.push(owner);
                }
              });
              if (property.status == "INWORKFLOW") {
                oldOwnerList.push.apply(oldOwnerList, newOwnerList);
                property.owners = oldOwnerList;
              } else {
                newOwnerList.push.apply(newOwnerList, oldOwnerList);
                property.owners = newOwnerList;
              }
            });
            _store2.default.dispatch(toggleSpinner());
            return _context22.abrupt("return", response);

          case 10:
            _context22.prev = 10;
            _context22.t0 = _context22["catch"](0);

            _store2.default.dispatch(toggleSpinner());
            _store2.default.dispatch(toggleSnackbar(true, { labelName: _context22.t0.message, labelKey: _context22.t0.message }, "error"));
            throw _context22.t0;

          case 15:
          case "end":
            return _context22.stop();
        }
      }
    }, _callee22, undefined, [[0, 10]]);
  }));

  return function getSearchResults(_x44, _x45) {
    return _ref25.apply(this, arguments);
  };
}();
// check assessee exist or not
var checkAssesseeExistOrNot = exports.checkAssesseeExistOrNot = function () {
  var _ref26 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee23(values, currentValue, name) {
    var ward, street, premisesType, premisesNo;
    return _regenerator2.default.wrap(function _callee23$(_context23) {
      while (1) {
        switch (_context23.prev = _context23.next) {
          case 0:
            ward = values.ward, street = values.street, premisesType = values.premisesType, premisesNo = values.premisesNo;

            if (!(name == "street" && currentValue && ward && premisesType && premisesNo)) {
              _context23.next = 6;
              break;
            }

            values.street = currentValue;
            return _context23.abrupt("return", checkAssessee(values));

          case 6:
            if (!(name == "premisesType" && currentValue && ward && street && premisesNo)) {
              _context23.next = 11;
              break;
            }

            values.premisesType = currentValue;
            return _context23.abrupt("return", checkAssessee(values));

          case 11:
            if (!(name == "premisesNo" && currentValue && ward && premisesType && street)) {
              _context23.next = 13;
              break;
            }

            return _context23.abrupt("return", checkAssessee((0, _extends3.default)({}, values, { premisesNo: currentValue })));

          case 13:
          case "end":
            return _context23.stop();
        }
      }
    }, _callee23, undefined);
  }));

  return function checkAssesseeExistOrNot(_x47, _x48, _x49) {
    return _ref26.apply(this, arguments);
  };
}();

var checkAssessee = exports.checkAssessee = function () {
  var _ref27 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee24(values) {
    var ward, street, premisesType, premisesNo, assesseeNo, query, queryObject, response, message;
    return _regenerator2.default.wrap(function _callee24$(_context24) {
      while (1) {
        switch (_context24.prev = _context24.next) {
          case 0:
            _context24.prev = 0;
            ward = values.ward, street = values.street, premisesType = values.premisesType, premisesNo = values.premisesNo, assesseeNo = values.assesseeNo;

            if (!(ward && street && premisesType && premisesNo)) {
              _context24.next = 23;
              break;
            }

            query = { wardNo: ward, street: street, premiseType: premisesType, premiseNo: premisesNo, asseseeNo: assesseeNo };
            queryObject = [];

            Object.keys(query).map(function (key) {
              queryObject.push({ key: key, value: query[key] });
            });

            _context24.next = 8;
            return (0, _api.httpRequestForPT)(_PTServiceUrls.urlCheckExistAssessee, "", queryObject, {});

          case 8:
            response = _context24.sent;

            if (!(response.tokenStatus == "invalid")) {
              _context24.next = 14;
              break;
            }

            showToast("Invalid Access Token. Please login again", "error");
            return _context24.abrupt("return", false);

          case 14:
            if (!(response.data && response.status == 200)) {
              _context24.next = 19;
              break;
            }

            _store2.default.dispatch((0, _actions2.toggleSnackbarAndSetText)(false, { labelName: "", labelKey: "" }, "error"));
            return _context24.abrupt("return", true);

          case 19:
            if (!(response.data && response.data.hasOwnProperty("Errors"))) {
              _context24.next = 23;
              break;
            }

            message = response.data.hasOwnProperty("Errors") && response.data.Errors && response.data.Errors.length > 0 && response.data.Errors[0].message;

            showToast(message, "error");
            return _context24.abrupt("return", false);

          case 23:
            _context24.next = 29;
            break;

          case 25:
            _context24.prev = 25;
            _context24.t0 = _context24["catch"](0);

            showToast(_context24.t0.message, "warning");
            return _context24.abrupt("return", false);

          case 29:
          case "end":
            return _context24.stop();
        }
      }
    }, _callee24, undefined, [[0, 25]]);
  }));

  return function checkAssessee(_x50) {
    return _ref27.apply(this, arguments);
  };
}();
//  api call for base values
var fetchBaseValueForSAF = exports.fetchBaseValueForSAF = function () {
  var _ref28 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee25() {
    var requestBody, response, valueList, baseValueList, message;
    return _regenerator2.default.wrap(function _callee25$(_context25) {
      while (1) {
        switch (_context25.prev = _context25.next) {
          case 0:
            requestBody = {
              MdmsCriteria: {
                moduleDetails: [{
                  moduleName: "PropertyTax",
                  masterDetails: [{ name: "UAA_BASE_VALUE", moduleCode: "ASMT" }]
                }]
              }
            };
            _context25.prev = 1;
            _context25.next = 4;
            return (0, _api.httpRequestForPT)(_PTServiceUrls.urlFormatSAFTableDropDown, "", [], requestBody, [], {}, true);

          case 4:
            response = _context25.sent;

            if (!(response.tokenStatus == "invalid")) {
              _context25.next = 10;
              break;
            }

            showToast("Invalid Access Token. Please login again", "warning");
            return _context25.abrupt("return", []);

          case 10:
            if (!(response.tokenStatus == "valid" && (response.status == 200 || response.status == 201))) {
              _context25.next = 16;
              break;
            }

            valueList = response.data.data;
            baseValueList = valueList && valueList.PropertyTax && valueList.PropertyTax.UAA_BASE_VALUE.length > 0 ? valueList.PropertyTax.UAA_BASE_VALUE.map(function (w) {
              return { label: w.name, value: w.code, code: w.code };
            }) : [];
            return _context25.abrupt("return", baseValueList);

          case 16:
            message = response.data.hasOwnProperty("Errors") && response.data.Errors && response.data.Errors.length > 0 && response.data.Errors[0].message;

            showToast(message, "error");
            return _context25.abrupt("return", []);

          case 19:
            _context25.next = 25;
            break;

          case 21:
            _context25.prev = 21;
            _context25.t0 = _context25["catch"](1);

            showToast(_context25.t0.message, "error");
            return _context25.abrupt("return", []);

          case 25:
          case "end":
            return _context25.stop();
        }
      }
    }, _callee25, undefined, [[1, 21]]);
  }));

  return function fetchBaseValueForSAF() {
    return _ref28.apply(this, arguments);
  };
}();

// report print handler
// export const reportPrintHandler = async (url, queryObject = [], requestBody = {}, reportName = "report", isGetMethod = false) => {
//   try {
//     // prettier-ignore
//     store.dispatch(showSpinner());
//     const response = await httpRequestForArrayBuffer(
//       url,
//       "",
//       queryObject,
//       requestBody,
//       [{ "Content-Type": "application/pdf" }],
//       {},
//       true,
//       isGetMethod
//     );
//     if (response.status === 400) {
//       if (response.data.hasOwnProperty("Errors") && response.data.Errors && response.data.Errors.length > 0 && response.data.Errors[0].message) {
//         showToast(response.data.Errors[0].message, "error");
//         store.dispatch(hideSpinner());
//       } else {
//         showToast("An error occurred while processing your request", "error");
//         store.dispatch(hideSpinner());
//       }
//     } else if ([200, 201].includes(response.status)) {
//       downloadBlob(response.data, `${reportName}.pdf`);
//       store.dispatch(hideSpinner());
//     } else {
//       store.dispatch(hideSpinner());
//       showToast("An error occurred while processing your request", "error");
//     }
//   } catch (error) {
//     showToast(error.message, "error");
//     store.dispatch(hideSpinner());
//   } finally {
//     store.dispatch(hideSpinner());
//   }
// };

var reportPrintHandler = exports.reportPrintHandler = function () {
  var _ref29 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee26(url) {
    var queryObject = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var requestBody = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var defaultReportName = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "report";
    var isGetMethod = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    var response, header, filenameMatch, reportName, extension;
    return _regenerator2.default.wrap(function _callee26$(_context26) {
      while (1) {
        switch (_context26.prev = _context26.next) {
          case 0:
            _context26.prev = 0;

            _store2.default.dispatch((0, _actions4.showSpinner)());

            _context26.next = 4;
            return (0, _api.httpRequestForArrayBuffer)(url, "", queryObject, requestBody, [{ "Content-Type": "application/octet-stream" }], {}, true, isGetMethod);

          case 4:
            response = _context26.sent;


            if (response.status === 400) {
              if (response.data.hasOwnProperty("Errors") && response.data.Errors && response.data.Errors.length > 0 && response.data.Errors[0].message) {
                showToast(response.data.Errors[0].message, "error");
              } else {
                showToast("An error occurred while processing your request", "error");
              }
            } else if ([200, 201].includes(response.status)) {
              header = response.headers["content-disposition"];
              //   const filenameMatch = header ? header.match(/filename="([^"]+)"/) : null;

              filenameMatch = header.match(/filename="?([^"]+)"?/);
              reportName = filenameMatch ? filenameMatch[1] : defaultReportName + ".pdf";
              extension = reportName.split(".").pop().toLowerCase();

              if (["pdf", "jpg", "jpeg", "png", "xlsx", "xls", "rar", "zip"].includes(extension)) {
                downloadBlob(response.data, reportName);
              } else {
                showToast("Unsupported file format", "error");
              }
            } else {
              showToast("An error occurred while processing your request", "error");
            }
            _context26.next = 11;
            break;

          case 8:
            _context26.prev = 8;
            _context26.t0 = _context26["catch"](0);

            showToast(_context26.t0.message, "error");

          case 11:
            _context26.prev = 11;

            _store2.default.dispatch((0, _actions4.hideSpinner)());
            return _context26.finish(11);

          case 14:
          case "end":
            return _context26.stop();
        }
      }
    }, _callee26, undefined, [[0, 8, 11, 14]]);
  }));

  return function reportPrintHandler(_x51) {
    return _ref29.apply(this, arguments);
  };
}();

var generatePrintableReportExcel = exports.generatePrintableReportExcel = function () {
  var _ref30 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee27(url) {
    var queryObject = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var requestBody = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var reportName = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "report";
    var contentType = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "application/pdf";
    var fileExtension = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : "pdf";
    var response;
    return _regenerator2.default.wrap(function _callee27$(_context27) {
      while (1) {
        switch (_context27.prev = _context27.next) {
          case 0:
            _context27.prev = 0;

            // prettier-ignore
            _store2.default.dispatch((0, _actions4.showSpinner)());
            _context27.next = 4;
            return (0, _api.httpRequestForArrayBuffer)(url, "", queryObject, requestBody, [{ "Content-Type": contentType }], {}, true);

          case 4:
            response = _context27.sent;

            if (response.status === 400) {
              if (response.data.hasOwnProperty("Errors") && response.data.Errors && response.data.Errors.length > 0 && response.data.Errors[0].message) {
                showToast(response.data.Errors[0].message, "error");
                _store2.default.dispatch((0, _actions4.hideSpinner)());
              } else {
                showToast("An error occurred while processing your request", "error");
                _store2.default.dispatch((0, _actions4.hideSpinner)());
              }
            } else if ([200, 201].includes(response.status)) {
              downloadBlob(response.data, reportName + "." + fileExtension);
              _store2.default.dispatch((0, _actions4.hideSpinner)());
            } else {
              _store2.default.dispatch((0, _actions4.hideSpinner)());
              showToast("An error occurred while processing your request", "error");
            }
            _context27.next = 12;
            break;

          case 8:
            _context27.prev = 8;
            _context27.t0 = _context27["catch"](0);

            showToast(_context27.t0.message, "error");
            _store2.default.dispatch((0, _actions4.hideSpinner)());

          case 12:
          case "end":
            return _context27.stop();
        }
      }
    }, _callee27, undefined, [[0, 8]]);
  }));

  return function generatePrintableReportExcel(_x56) {
    return _ref30.apply(this, arguments);
  };
}();

var downloadBlob = exports.downloadBlob = function downloadBlob(blobData, filename) {
  var extension = filename.split(".").pop();
  var mimeType = getMimeType(extension);
  var blob = new Blob([blobData], { type: mimeType });
  var url = URL.createObjectURL(blob);
  var a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
};
var getMimeType = function getMimeType(extension) {
  switch (extension.toLowerCase()) {
    case "pdf":
      return "application/pdf";
    case "xlsx":
      return "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    case "xls":
      return "application/vnd.ms-excel";
    case "zip":
      return "application/zip";
    default:
      return "application/octet-stream";
  }
};

// check all the table values of saf format has values or not
function checkAllKeysValuesInFormatTable(arr) {
  for (var i = 0; i < arr.length; i++) {
    var obj = arr[i];
    for (var key in obj) {
      if (obj.hasOwnProperty(key)) {
        var value = obj[key];
        if (value === "0" || value === "") {
          return false;
        }
      }
    }
  }
  return true;
}

var downloadFile = exports.downloadFile = function () {
  var _ref31 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee28(selectedFile) {
    var buffer, byteArray, blob, link;
    return _regenerator2.default.wrap(function _callee28$(_context28) {
      while (1) {
        switch (_context28.prev = _context28.next) {
          case 0:
            if (!selectedFile) {
              _context28.next = 14;
              break;
            }

            _context28.next = 3;
            return selectedFile.arrayBuffer();

          case 3:
            buffer = _context28.sent;
            byteArray = new Int8Array(buffer);
            blob = new Blob([byteArray], { type: "application/pdf" });
            link = document.createElement("a");

            link.href = window.URL.createObjectURL(blob);
            link.download = selectedFile.name;
            document.body.appendChild(link);

            link.click();

            document.body.removeChild(link);
            _context28.next = 15;
            break;

          case 14:
            alert("File download failed!");

          case 15:
          case "end":
            return _context28.stop();
        }
      }
    }, _callee28, undefined);
  }));

  return function downloadFile(_x62) {
    return _ref31.apply(this, arguments);
  };
}();

// get ward list on page load
var getAdjournType = exports.getAdjournType = function () {
  var _ref32 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee29() {
    var adjournTypeList, mdmsBody, response, adjounrData;
    return _regenerator2.default.wrap(function _callee29$(_context29) {
      while (1) {
        switch (_context29.prev = _context29.next) {
          case 0:
            // call ward list
            adjournTypeList = [{ value: "", label: "Select" }];
            mdmsBody = {
              MdmsCriteria: {
                moduleDetails: [{
                  moduleName: "PropertyTax",
                  masterDetails: [{ name: "UAA_ADJOURNMENT_TYPE", moduleCode: "ASMT" }]
                }]
              }
            };
            _context29.next = 4;
            return (0, _api.httpRequestForPT)(_PTServiceUrls.urlFormatSAFTableDropDown, "", [], mdmsBody);

          case 4:
            response = _context29.sent;

            if (!(response.data && response.data.data && response.data.data.PropertyTax && response.data.data.PropertyTax.UAA_ADJOURNMENT_TYPE && response.data.data.PropertyTax.UAA_ADJOURNMENT_TYPE.length > 0)) {
              _context29.next = 9;
              break;
            }

            adjounrData = response.data.data.PropertyTax.UAA_ADJOURNMENT_TYPE;

            adjounrData.map(function (w) {
              adjournTypeList.push({
                name: w.name,
                code: w.code,
                label: w.name,
                value: w.code
              });
            });
            return _context29.abrupt("return", adjournTypeList);

          case 9:
          case "end":
            return _context29.stop();
        }
      }
    }, _callee29, undefined);
  }));

  return function getAdjournType() {
    return _ref32.apply(this, arguments);
  };
}();

var isThereMinimumNoPresent = exports.isThereMinimumNoPresent = function isThereMinimumNoPresent(array) {
  var count = 0;
  for (var i = 0; i < array.length; i++) {
    var obj = array[i];
    if (obj.alreadyAssessed === "N") count = 1;
  }
  return count == 0 ? false : true;
};

var getCurrentQuarterAndYear = exports.getCurrentQuarterAndYear = function getCurrentQuarterAndYear() {
  var now = new Date();

  var quarter = Math.ceil(now.getMonth() / 3);
  var year = now.getFullYear();
  return { quarter: quarter, year: year };
};
// call api for ordered by list
var getOrderedByData = exports.getOrderedByData = function () {
  var _ref33 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee30() {
    var mdmsBody, response;
    return _regenerator2.default.wrap(function _callee30$(_context30) {
      while (1) {
        switch (_context30.prev = _context30.next) {
          case 0:
            mdmsBody = {
              MdmsCriteria: {
                tenantId: _common2.default.tenantId,
                moduleDetails: [{
                  moduleName: "PropertyTax",
                  masterDetails: [{
                    name: "Ordered By",
                    officeCode: localStorage.getItem("officeId") || "",
                    moduleCode: "ASMT"
                  }]
                }]
              }
            };
            _context30.prev = 1;
            response = null;
            _context30.next = 5;
            return (0, _api.httpRequestForPT)(_PTServiceUrls.urlFormatSAFTableDropDown, "_search", [], mdmsBody);

          case 5:
            response = _context30.sent;

            if (!(response.tokenStatus === "invalid")) {
              _context30.next = 11;
              break;
            }

            showToast("Invalid Access Token. Please login again", "error");
            return _context30.abrupt("return", []);

          case 11:
            if (!(response.tokenStatus === "valid" && [200, 201].includes(response.status))) {
              _context30.next = 15;
              break;
            }

            return _context30.abrupt("return", response.data.data || []);

          case 15:
            if (response.data.hasOwnProperty("Errors") && response.data.Errors && response.data.Errors.length > 0 && response.data.Errors[0].message) {
              showToast(response.data.Errors[0].message, "error");
            } else showToast("Something went wrong!", "error");

          case 16:
            _context30.next = 21;
            break;

          case 18:
            _context30.prev = 18;
            _context30.t0 = _context30["catch"](1);

            showToast(_context30.t0.message, "error");

          case 21:
          case "end":
            return _context30.stop();
        }
      }
    }, _callee30, undefined, [[1, 18]]);
  }));

  return function getOrderedByData() {
    return _ref33.apply(this, arguments);
  };
}();

var getSearchPropertyData = exports.getSearchPropertyData = function () {
  var _ref34 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee31(name) {
    var mdmsBody, response;
    return _regenerator2.default.wrap(function _callee31$(_context31) {
      while (1) {
        switch (_context31.prev = _context31.next) {
          case 0:
            mdmsBody = {
              MdmsCriteria: {
                tenantId: _common2.default.tenantId,
                moduleDetails: [{
                  moduleName: "PropertyTax",
                  masterDetails: [{
                    name: name,
                    filter: "",
                    moduleCode: "ASMT",
                    officeCode: localStorage.getItem("officeId") || ""
                  }]
                }]
              }
            };
            _context31.prev = 1;
            response = null;
            _context31.next = 5;
            return (0, _api.httpRequestForPT)(_PTServiceUrls.urlFormatSAFTableDropDown, "_search", [], mdmsBody);

          case 5:
            response = _context31.sent;

            if (!(response.tokenStatus === "invalid")) {
              _context31.next = 11;
              break;
            }

            showToast("Invalid Access Token. Please login again", "error");
            return _context31.abrupt("return", []);

          case 11:
            if (!(response.tokenStatus === "valid" && [200, 201].includes(response.status))) {
              _context31.next = 15;
              break;
            }

            return _context31.abrupt("return", response.data.data || []);

          case 15:
            if (response.data.hasOwnProperty("Errors") && response.data.Errors && response.data.Errors.length > 0 && response.data.Errors[0].message) {
              showToast(response.data.Errors[0].message, "error");
            } else showToast("Something went wrong!", "error");

          case 16:
            _context31.next = 21;
            break;

          case 18:
            _context31.prev = 18;
            _context31.t0 = _context31["catch"](1);

            showToast(_context31.t0.message, "error");

          case 21:
          case "end":
            return _context31.stop();
        }
      }
    }, _callee31, undefined, [[1, 18]]);
  }));

  return function getSearchPropertyData(_x63) {
    return _ref34.apply(this, arguments);
  };
}();

// get ward list by passing the office id
var getWardListByOfficeID = exports.getWardListByOfficeID = function () {
  var _ref35 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee32(officeCode) {
    var response, selectedWard, wardList;
    return _regenerator2.default.wrap(function _callee32$(_context32) {
      while (1) {
        switch (_context32.prev = _context32.next) {
          case 0:
            _context32.prev = 0;
            _context32.next = 3;
            return (0, _api.httpRequestForPT)(_PTServiceUrls.urlOfficewithWardMapping, "", [{ key: "officeCode", value: officeCode }]);

          case 3:
            response = _context32.sent;

            if (!(response.tokenStatus === "invalid")) {
              _context32.next = 8;
              break;
            }

            showToast("Invalid Access Token. Please login again", "error");
            _context32.next = 18;
            break;

          case 8:
            if (!(response.tokenStatus === "valid" && [200, 201].includes(response.status))) {
              _context32.next = 15;
              break;
            }

            selectedWard = response.data.data;
            wardList = [{ value: "0", label: "All Ward" }];

            selectedWard.map(function (_ref36) {
              var id = _ref36.id,
                  name = _ref36.name;

              wardList.push({ value: id, label: name });
              return wardList;
            });

            return _context32.abrupt("return", wardList);

          case 15:
            if (!(response.data.hasOwnProperty("Errors") && response.data.Errors && response.data.Errors.length > 0 && response.data.Errors[0].message)) {
              _context32.next = 18;
              break;
            }

            showToast(response.data.Errors[0].message, "error");
            return _context32.abrupt("return", []);

          case 18:
            _context32.next = 23;
            break;

          case 20:
            _context32.prev = 20;
            _context32.t0 = _context32["catch"](0);

            showToast(_context32.t0.message, "error");

          case 23:
          case "end":
            return _context32.stop();
        }
      }
    }, _callee32, undefined, [[0, 20]]);
  }));

  return function getWardListByOfficeID(_x64) {
    return _ref35.apply(this, arguments);
  };
}();

var getMultippleSearchPropertyData = exports.getMultippleSearchPropertyData = function () {
  var _ref37 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee33(nameList) {
    var arrayOfObject, mdmsBody, response;
    return _regenerator2.default.wrap(function _callee33$(_context33) {
      while (1) {
        switch (_context33.prev = _context33.next) {
          case 0:
            arrayOfObject = nameList.length > 0 ? nameList.map(function (name) {
              return {
                name: name,
                moduleCode: "ASMT",
                officeCode: localStorage.getItem("officeId") || ""
              };
            }) : [];
            mdmsBody = {
              MdmsCriteria: {
                tenantId: _common2.default.tenantId,
                moduleDetails: [{
                  moduleName: "PropertyTax",
                  masterDetails: arrayOfObject
                }]
              }
            };
            _context33.prev = 2;
            response = null;
            _context33.next = 6;
            return (0, _api.httpRequestForPT)(_PTServiceUrls.urlFormatSAFTableDropDown, "_search", [], mdmsBody);

          case 6:
            response = _context33.sent;

            if (!(response.tokenStatus === "invalid")) {
              _context33.next = 12;
              break;
            }

            showToast("Invalid Access Token. Please login again", "error");
            return _context33.abrupt("return", []);

          case 12:
            if (!(response.tokenStatus === "valid" && [200, 201].includes(response.status))) {
              _context33.next = 16;
              break;
            }

            return _context33.abrupt("return", response.data.data || []);

          case 16:
            if (response.data.hasOwnProperty("Errors") && response.data.Errors && response.data.Errors.length > 0 && response.data.Errors[0].message) {
              showToast(response.data.Errors[0].message, "error");
            } else showToast("Something went wrong!", "error");

          case 17:
            _context33.next = 22;
            break;

          case 19:
            _context33.prev = 19;
            _context33.t0 = _context33["catch"](2);

            showToast(_context33.t0.message, "error");

          case 22:
          case "end":
            return _context33.stop();
        }
      }
    }, _callee33, undefined, [[2, 19]]);
  }));

  return function getMultippleSearchPropertyData(_x65) {
    return _ref37.apply(this, arguments);
  };
}();
//  convert to byte array
var convertToByteArray = exports.convertToByteArray = function () {
  var _ref38 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee34(file) {
    var buffer, byteArray;
    return _regenerator2.default.wrap(function _callee34$(_context34) {
      while (1) {
        switch (_context34.prev = _context34.next) {
          case 0:
            _context34.next = 2;
            return file.arrayBuffer();

          case 2:
            buffer = _context34.sent;
            byteArray = new Int8Array(buffer);
            return _context34.abrupt("return", byteArray);

          case 5:
          case "end":
            return _context34.stop();
        }
      }
    }, _callee34, undefined);
  }));

  return function convertToByteArray(_x66) {
    return _ref38.apply(this, arguments);
  };
}();

// Api generic function
var handleRequest = exports.handleRequest = function () {
  var _ref39 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee35(endpoint) {
    var requestData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var setLoadingStatus = arguments[2];
    var successMessage = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var payload, message;
    return _regenerator2.default.wrap(function _callee35$(_context35) {
      while (1) {
        switch (_context35.prev = _context35.next) {
          case 0:
            setLoadingStatus(true);

            _context35.prev = 1;
            _context35.next = 4;
            return (0, _api.httpRequestForPT)(endpoint, "", [], requestData, [], {}, true);

          case 4:
            payload = _context35.sent;

            if (!(payload.tokenStatus === "invalid")) {
              _context35.next = 10;
              break;
            }

            setLoadingStatus(false);
            showToast("Invalid Access Token. Please login again");
            _context35.next = 19;
            break;

          case 10:
            if (!(payload.tokenStatus === "valid" && (payload.status === 200 || payload.status === 201))) {
              _context35.next = 16;
              break;
            }

            setLoadingStatus(false);
            if (successMessage) {
              showToast(successMessage, "success", 450000);
            }
            // Return relevant data from the response
            return _context35.abrupt("return", payload.data);

          case 16:
            // Custom error show
            message = payload.data.hasOwnProperty("Errors") && payload.data.Errors && payload.data.Errors.length > 0 && payload.data.Errors[0].message;

            setLoadingStatus(false);
            showToast(message, "error", 450000);

          case 19:
            _context35.next = 24;
            break;

          case 21:
            _context35.prev = 21;
            _context35.t0 = _context35["catch"](1);

            showToast(_context35.t0);

          case 24:
          case "end":
            return _context35.stop();
        }
      }
    }, _callee35, undefined, [[1, 21]]);
  }));

  return function handleRequest(_x67) {
    return _ref39.apply(this, arguments);
  };
}();

// convert bytearray into file
var convertByteArrayToFile = exports.convertByteArrayToFile = function convertByteArrayToFile(byte, fileName) {
  var byteArray = new Uint8Array(byte);

  // Create a Blob from the byte array
  var blob = new Blob([byteArray]);

  // Create a File object from the Blob
  var file = new File([blob], fileName, { type: "application/octet-stream" });
  return file;
};

// convert to file from base64
var convertBase64ToFile = exports.convertBase64ToFile = function convertBase64ToFile(base64String, fileName) {
  var base64WithoutPrefix = base64String.replace(/^data:[^;]+;base64,/, "");

  var binaryData = Uint8Array.from(atob(base64WithoutPrefix), function (char) {
    return char.charCodeAt(0);
  });

  var blob = new Blob([binaryData], { type: "application/pdf" });
  var file = new File([blob], fileName || "file", { type: "application/pdf" });

  return file;
};
// fomrat time 24hr to 12hr
var changeFormat24HrTo12Hr = exports.changeFormat24HrTo12Hr = function changeFormat24HrTo12Hr(time) {
  if (!time) {
    return "";
  }

  var timeParts = time.split(":");
  var hours = parseInt(timeParts[0], 10);
  var minutes = timeParts[1];

  if (hours >= 12) {
    return (hours === 12 ? 12 : hours - 12) + ":" + minutes + " PM";
  } else {
    return (hours === 0 ? 12 : hours) + ":" + minutes + " AM";
  }
};
// download report on custom button click
var downloadCustomReport = exports.downloadCustomReport = function downloadCustomReport() {
  var reportName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var searchForm = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var requestData = {};
  // HEARING_DATE
  // before calling to api change the date format accodingly
  // check whether the key has "DATE", then change the format
  for (var key in searchForm) {
    if (key.endsWith("_DATE")) {
      // Convert the string to a Date object
      var date = new Date(searchForm[key]);

      // Get local date components
      var day = date.getDate();
      var month = date.getMonth() + 1; // Month starts from 0
      var year = date.getFullYear();

      var formattedDate = (month < 10 ? "0" : "") + month + "/" + (day < 10 ? "0" : "") + day + "/" + year;

      requestData[key] = formattedDate;
    } else requestData[key] = searchForm[key];
  }
  // dd-mm-yyyy
  var requestObject = { key: reportName.toUpperCase(), tenantId: "km", data: {} };
  requestObject.data[reportName.toUpperCase()] = requestData;
  reportPrintHandler(_PTServiceUrls.urlCustomReport, {}, requestObject, reportName);
};

var handleReport = exports.handleReport = function handleReport(queryObject) {
  reportPrintHandler("/ws-services/common/_print", queryObject, "", "");
};

// Valid format: Quarter/Year (e.g., 1/2023)
var isProposedQtrValid = exports.isProposedQtrValid = function isProposedQtrValid(value) {
  var regex = /^[1-4]{1}\/[0-9]{4}$/;
  return regex.test(value);
};

function convertTo12HourFormat(time) {
  var _time$split$map = time.split(":").map(Number),
      _time$split$map2 = (0, _slicedToArray3.default)(_time$split$map, 2),
      hour = _time$split$map2[0],
      minute = _time$split$map2[1];

  var period = hour >= 12 ? "PM" : "AM";
  var adjustedHour = hour % 12 || 12; // Converts '0' to '12'
  return adjustedHour + ":" + (minute < 10 ? "0" + minute : minute) + " " + period;
}

function updateSlots(array) {
  return array.map(function (item) {
    if (/^\d{2}:\d{2}$/.test(item.slot)) {
      item.slot = convertTo12HourFormat(item.slot);
    }
    return item;
  });
}
// common hearing convert uppercase to normal
function convertName(name) {
  var words = name.split(" "); // Split the string into an array of words
  var convertedWords = words.map(function (word) {
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  });
  return convertedWords.join(" "); // Join the converted words back with spaces
}

// Qtr validation like qtr/Year -> YearQtr(1/2000 => 20001)
var formatOldQuarter = exports.formatOldQuarter = function formatOldQuarter(effectiveQtr) {
  var _effectiveQtr$split = effectiveQtr.split("/"),
      _effectiveQtr$split2 = (0, _slicedToArray3.default)(_effectiveQtr$split, 2),
      quarter = _effectiveQtr$split2[0],
      year = _effectiveQtr$split2[1];

  return "" + year + quarter;
};
// get file store document download

// FIXME: Remove this function
// demo function to show hide the button
var showHideButtonForText = exports.showHideButtonForText = function showHideButtonForText() {
  var status = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  return status;
};

var getCurrentFinancialYear = exports.getCurrentFinancialYear = function getCurrentFinancialYear() {
  var today = new Date();
  var curMonth = today.getMonth();
  var fiscalYr = "";
  if (curMonth > 3) {
    var nextYr1 = (today.getFullYear() + 1).toString();
    fiscalYr = today.getFullYear().toString() + "-" + nextYr1;
  } else {
    var nextYr2 = today.getFullYear().toString();
    fiscalYr = (today.getFullYear() - 1).toString() + "-" + nextYr2;
  }
  return fiscalYr;
};

var convertDateToEpoch = exports.convertDateToEpoch = function convertDateToEpoch(dateString) {
  var dayStartOrEnd = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "dayend";

  //example input format : "2018-10-02"
  try {
    var parts = dateString.match(/(\d{4})-(\d{1,2})-(\d{1,2})/);
    var DateObj = new Date(Date.UTC(parts[1], parts[2] - 1, parts[3]));
    DateObj.setMinutes(DateObj.getMinutes() + DateObj.getTimezoneOffset());
    if (dayStartOrEnd === "dayend") {
      DateObj.setHours(DateObj.getHours() + 24);
      DateObj.setSeconds(DateObj.getSeconds() - 1);
    }
    return DateObj.getTime();
  } catch (e) {
    return dateString;
  }
};
var ifUserRoleExists = exports.ifUserRoleExists = function ifUserRoleExists(role) {
  var userInfo = JSON.parse((0, _localStorageUtils.getUserInfo)());
  var roles = (0, _get2.default)(userInfo, "roles");
  var roleCodes = roles ? roles.map(function (role) {
    return role.code;
  }) : [];
  if (roleCodes.indexOf(role) > -1) {
    return true;
  } else return false;
};
var validateFields = exports.validateFields = function validateFields(objectJsonPath, state, dispatch) {
  var screen = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "apply";

  var fields = (0, _get2.default)(state.screenConfiguration.screenConfig[screen], objectJsonPath, {});
  var isFormValid = true;
  for (var variable in fields) {
    if (fields.hasOwnProperty(variable)) {
      if (fields[variable] && fields[variable].props && (fields[variable].props.disabled === undefined || !fields[variable].props.disabled) && !validate(screen, (0, _extends3.default)({}, fields[variable], {
        value: (0, _get2.default)(state.screenConfiguration.preparedFinalObject, fields[variable].jsonPath)
      }), dispatch, true)) {
        isFormValid = false;
      }
    }
  }
  return isFormValid;
};
// convert the image to Base64
var getBase64ImageFromURL = exports.getBase64ImageFromURL = function () {
  var _ref40 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee36(url) {
    var res, blob;
    return _regenerator2.default.wrap(function _callee36$(_context36) {
      while (1) {
        switch (_context36.prev = _context36.next) {
          case 0:
            _context36.next = 2;
            return fetch(url);

          case 2:
            res = _context36.sent;
            _context36.next = 5;
            return res.blob();

          case 5:
            blob = _context36.sent;
            return _context36.abrupt("return", new Promise(function (resolve, reject) {
              var reader = new FileReader();
              reader.onloadend = function () {
                return resolve(reader.result);
              };
              reader.onerror = reject;
              reader.readAsDataURL(blob);
            }));

          case 7:
          case "end":
            return _context36.stop();
        }
      }
    }, _callee36, undefined);
  }));

  return function getBase64ImageFromURL(_x75) {
    return _ref40.apply(this, arguments);
  };
}();


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/utils/commons.js
// module id = 25
// module chunks = 1137